/* global bodymovin */
/* global Stripe */
/* global dataLayer */
/* global stripeApiKey */

import { aeTracker, initializeTrackerEvents } from "../../typescript/app";
import { tooltip } from "./tooltip";
import { codemarkup } from "./codemarkup";
import { cookies } from "./cookies";
import { fileload } from "./loader";
import _ from "./animations";

const hubspotContactFormId = "80a899de-ca2a-4667-b1c5-9ba6fab9e474";
const hubspotSalesFormId = "95d29081-bec4-45da-ba44-c09c37ae6252";

/* eslint-disable */
/* Touch extension (https://github.com/furf/jquery-ui-touch-punch) */
!function (a) { function f(a, b) { if (!(a.originalEvent.touches.length > 1)) { a.preventDefault(); var c = a.originalEvent.changedTouches[0], d = document.createEvent("MouseEvents"); d.initMouseEvent(b, !0, !0, window, 1, c.screenX, c.screenY, c.clientX, c.clientY, !1, !1, !1, !1, 0, null), a.target.dispatchEvent(d) } } if (a.support.touch = "ontouchend" in document, a.support.touch) { var e, b = a.ui.mouse.prototype, c = b._mouseInit, d = b._mouseDestroy; b._touchStart = function (a) { var b = this; !e && b._mouseCapture(a.originalEvent.changedTouches[0]) && (e = !0, b._touchMoved = !1, f(a, "mouseover"), f(a, "mousemove"), f(a, "mousedown")) }, b._touchMove = function (a) { e && (this._touchMoved = !0, f(a, "mousemove")) }, b._touchEnd = function (a) { e && (f(a, "mouseup"), f(a, "mouseout"), this._touchMoved || f(a, "click"), e = !1) }, b._mouseInit = function () { var b = this; b.element.bind({ touchstart: a.proxy(b, "_touchStart"), touchmove: a.proxy(b, "_touchMove"), touchend: a.proxy(b, "_touchEnd") }), c.call(b) }, b._mouseDestroy = function () { var b = this; b.element.unbind({ touchstart: a.proxy(b, "_touchStart"), touchmove: a.proxy(b, "_touchMove"), touchend: a.proxy(b, "_touchEnd") }), d.call(b) } } }(jQuery);
/* eslint-enable */

/* Top menu and general stuff
---------------------------------------------------------------- */
var topmenu = function () {
  return {
    initialize: function () {
      // Attach
      $('.top .menu-t1 ul li.exp').on('mouseenter', function () {
        // If not open, show
        if ($(this).find('.drop').attr('data-open') === 'false') {
          $(this).find('.drop').addClass('open');
        }
      });

      // Attach
      $('.top .menu-t1 ul li.exp').on('mouseleave', function () {
        // If open, hide
        if ($(this).find('.drop').hasClass('open')) {
          $(this).find('.drop').removeClass('open');
        }
      });

      // Prevent click
      $('.top .menu-t1 #solexp').on('click', function () {
        // If not open, show
        if ($(this).find('.drop').attr('data-open') === 'false') {
          $(this).find('.drop').addClass('open');
        }

        // Return
        return false;
      });

      // Mobile menu click
      $('.top .menu-m .menu-m-btn').on('click', () => {
        $('.menu-m .drop').addClass('active');
      });

      // Mobile menu hide
      $('.top .menu-m .drop .close').on('click', () => {
        $('.menu-m .drop').removeClass('active');
      });

      // Attach scrolling state when scrolling
      if ($(window).scrollTop() > 0) {
        $('.top').addClass('-scroll');
      } else {
        $('.top').removeClass('-scroll');
      }

      // Attach scrolling state when scrolling
      $(window).on('scroll', () => {
        if ($(window).scrollTop() > 0) {
          $('.top').addClass('-scroll');
        } else {
          $('.top').removeClass('-scroll');
        }
      });

      // Anchor menu
      topmenu.anchormenubuild();

      // Anchor copy append
      topmenu.anchorcopyappend();

      // Copy desktop menu to mobile menu
      $("#moblftmnu").append($("#desklftmnu").clone());

      // Menu anchor
      $('#desklftmnu .anchor').on('click', function () { topmenu.gotoanchor(this); return false; });

    },
    initializeload: function () {
      // Any anthor?
      topmenu.anchorinit();
    },
    gotoanchor: function (f) {
      // Get anchor
      let sec = $(f).attr('data-rel');
      let ref = $(f).attr('href');

      // Remove #
      ref = ref.replace(/#/g, '');

      // No ref, try data-rel
      if (ref == '') {
        ref = 'anchor-' + sec;
      }

      // Get top height
      let tp = $('.top').outerHeight();

      // Exists?
      if ($('#' + ref).length) {
        // Locate top
        let t = $('#' + ref).offset().top - tp - 50;

        // Scroll to top
        $('html, body').animate({ scrollTop: t }, 'slow', 'easeInOutQuart');
      } else {
        // Loop through all links
        $('a').each(function () {
          // Get name
          let nam = $(this).attr('name');

          // Match?
          if (nam == ref) {
            // Locate top
            let t = $(this).offset().top - tp - 50;

            // Scroll to top
            setTimeout(function () {
              $('html, body').animate({ scrollTop: t }, 'slow', 'easeInOutQuart');
            }, 500);

            // Break
            return false;
          }
        });
      }
    },
    anchorinit: function () {
      // Get hash
      let hsh = window.location.hash;
      // Remove #
      let ref = hsh.replace(/#/g, '');

      // Any ref?
      if (ref != '') {
        // Loop through all links
        $('a').each(function () {
          // Get name
          let nam = $(this).attr('name');
          let fid = $(this).attr('id');

          // Match?
          if (nam == ref || fid == ref) {
            // Get top + opera heights
            let th = $('.top').outerHeight();
            // Locate top
            let t = $(this).offset().top - th - 50;

            // Scroll to top
            setTimeout(function () {
              $('html, body').animate({ scrollTop: t }, 'slow', 'easeInOutQuart');
            }, 500);

            // Break
            return false;
          }
        });
      }
    },
    anchormenubuild: function () {
      // Use?
      if ($('.anchormenubuild').length) {
        // Reset
        $('#desklftmnu .anchormenubuild').html('');
        // Loop through all links
        $('.cms .anchor').each(function () {
          // Get name and ID
          let nam = $(this).attr('name');
          let fid = $(this).attr('id');
          let txt = $(this).text();
          // Anchor use
          let au = '', auc = '';

          // Anchor ID to use
          if (nam != '' && typeof nam !== 'undefined') {
            au = nam;
          } else if (fid != '' && typeof fid !== 'undefined') {
            au = fid;
          }

          // Remove "anchor-" from string
          auc = au.replace(/anchor-/g, '');

          // Subanchor?
          if ($(this).hasClass('subanchor')) {
            txt = '- ' + txt;
          }

          // Iteem
          let itm = '<li><a href="#' + au + '" title="" data-rel="' + auc + '" class="anchor">' + txt + '</a></li>';
          // Add to menu
          $('#desklftmnu .anchormenubuild').append(itm);
        });
      }
    },
    anchorcopyappend: function () {
      // Loop through all links
      $('.cms .anchor').each(function () {
        // Get name and ID
        let nam = $(this).attr('name');
        let fid = $(this).attr('id');
        // Anchor use
        let au = '';
        // Anchor ID to use
        if (nam != '' && typeof nam !== 'undefined') {
          au = nam;
        } else if (fid != '' && typeof fid !== 'undefined') {
          au = fid;
        }

        // Get location
        let baseloc = location.protocol + '//' + location.host + location.pathname + '#' + au;
        // Append
        $(this).append('<span class="copylink" data-url="' + baseloc + '"><span class="material-icons">link</span></span>');
      });

      // Anchor copy
      $('.cms .copylink').on('click', function () { topmenu.anchorcopy(this); return false; });
    },
    anchorcopy: function (f) {
      // Get URL
      let url = $(f).attr('data-url');
      // Attach copy
      document.addEventListener('copy', function (e) {
        e.clipboardData.setData('text/plain', url);
        e.preventDefault();
      }, true);

      // Copy
      document.execCommand('copy');
      // Copied
      notificator.show('Copied', true);
    },
    observefixmenu: function () {
      // Exists?
      let fxpoint = 0;
      if ($('#desklftmnu').length) {
        // Scroll top
        let t = $(window).scrollTop();
        let wh = $(window).height();
        let ft = parseInt($('.footer').offset().top);
        let th = $('.top').outerHeight();

        // Any extra footer elements to observe?
        if ($('.addtofoot').length) {
          ft = ft - parseInt($('.addtofoot').outerHeight());
        }

        // If we get close to the footer, make the left menu absolute
        if (t + wh > ft) {
          // If we haven't captured a fixpoint, capture it
          if (fxpoint === 0) {
            fxpoint = parseInt(t + th);
          }

          // Add
          $('#doc').addClass('fxlftmnu');
          // Fix left menu
          $(".sticky-box").css('top', fxpoint + 'px');
        } else {
          // Reset fix point
          fxpoint = 0;
          // Remove
          $('#doc').removeClass('fxlftmnu');
          // Reset top
          $(".sticky-box").css('top', '');
        }
      }
    },
    observeanchor: function () {
      // Scroll top
      let t = $(document).scrollTop();
      // Closest
      let store;
      let xi = $(window).height();

      // Loop
      $(".cms .anchor").each(function () {
        // Get reference
        let fid = $(this).attr('id');
        let frd = $(this).attr('name');
        let fit = $(this).offset().top;

        // Using "id"
        if (fid == '' || typeof fid === "undefined") {
          fid = '';
        }

        // Using "name"
        if (frd != '' && typeof frd !== "undefined") {
          fid = frd;
        }

        // Closest to top
        if (fit <= (t + xi)) {
          store = fid.replace(/anchor-/g, '');
        }
      });

      // Reset
      $(".sticky-box .sublist a").removeClass('selected');
      // Set
      $(".sticky-box .sublist").find("[data-rel='" + store + "']").addClass('selected');
    }
  };
}();

// Attach
$(document).ready(function () { topmenu.initialize(); });
$(window).scroll(function () { topmenu.observefixmenu(); topmenu.observeanchor(); });

// Run anchor scroll to
window.addEventListener('load', function () { topmenu.initializeload(); });
/* Tooltips for frontpage slider
---------------------------------------------------------------- */

var frontpageslider = function () {
  return {
    initialize: function () {
      // Any slider?
      if ($('#slideset').length) {
        // Get active element
        setInterval(function () { frontpageslider.updatetext(); }, 1000);
        // Attach
        $('#slideset .isl').on('mouseenter', function () {
          // Call
          frontpageslider.over(this);
        });

        // Attach
        $('#slideset').on('mouseleave', function () {
          // Call
          frontpageslider.out(this);
        });
      }
    },
    updatetext: function () {
      // Find tooltip
      $('#slideset .isl').each(function () {
        // Get top
        let tp = parseInt($(this).css('top'));

        // If top, then use that element
        if (tp == '0') {
          // Set object
          let obj = $(this);
          // Get title
          let tit = $(obj).attr('title');
          // Update label
          $('#ttipctn .txil').text(tit);
        }
      });
    },
    over: function (f) {
      // Add
      $('#slidesetma').addClass('sover');
    },
    out: function (f) {
      // Remove
      $('#slidesetma').removeClass('sover');
    }
  };
}();

// Attach
$(document).ready(function () { frontpageslider.initialize(); });

/* Color grid (used on frontpage tabs)
---------------------------------------------------------------- */
var colorgrid = function () {
  return {
    initialize: function () {
      // Heights array
      let heights = [];

      // Set active
      $('.engage .ftrs .content .lst').addClass('active');
      $('.engage .ftrs .content .lst li.slide').addClass('active');

      // Loop items, add heights to array
      for (let i = 0; i < $('.engage .ftrs .content .lst li.slide').length; i++) {
        heights.push($($('.engage .ftrs .content .lst li.slide')[i]).outerHeight());
      }

      // Max height
      let maxHeight = 0;

      // Loop heights, set heightest variable
      for (let i = 0; i < heights.length; i++) {
        if (maxHeight < heights[i]) {
          maxHeight = heights[i];
        }
      }

      // Set
      $('.engage .ftrs').css('height', (maxHeight + 324) + 'px');
      $('.engage .ftrs .content .lst').css('height', maxHeight + 'px');
      $('.engage .ftrs .content .lst').removeClass('active');
      $('.engage .ftrs .content .lst li.slide').removeClass('active');
      $('.engage .ftrs .content .lst').first().addClass('active');
      $('.engage .ftrs .content .lst.active li.slide').first().addClass('active');

      // On window resize
      $(window).on('resize', (e) => {
        // Find active items
        const currentActiveSlideList = $('.engage .ftrs .content .lst.active');
        const currentActiveSlide = $(currentActiveSlideList).find('.slide.active');

        // Height array
        let heights = [];

        // Set
        $('.engage .ftrs .content .lst').addClass('active');
        $('.engage .ftrs .content .lst li.slide').addClass('active');

        // Loop heights, set heightest variable
        for (let i = 0; i < $('.engage .ftrs .content .lst li.slide').length; i++) {
          heights.push($($('.engage .ftrs .content .lst li.slide')[i]).outerHeight());
        }

        // Set max height variable
        let maxHeight = 0;

        // Loop heights, set heightest variable
        for (let i = 0; i < heights.length; i++) {
          if (maxHeight < heights[i]) {
            maxHeight = heights[i];
          }
        }

        // Set
        $('.engage .ftrs').css('height', (maxHeight + 324) + 'px');
        $('.engage .ftrs .content .lst').css('height', maxHeight + 'px');
        $('.engage .ftrs .content .lst').removeClass('active');
        $('.engage .ftrs .content .lst li.slide').removeClass('active');

        // Set active
        $(currentActiveSlideList).addClass('active');
        $(currentActiveSlide).addClass('active');
      });

      $('.engage .color-grid .item.item-bdr').on('click', (e) => {
        // Object
        let item = $(e.currentTarget);

        // Active?
        if (!$(item).hasClass('active')) {
          // Get indexes
          let itemIndex = $('.engage .color-grid .item').index(item);
          let itemCardsList = $('.engage .ftrs .cards .lst')[itemIndex];
          let itemContentList = $('.engage .ftrs .content .lst')[itemIndex];
          let firstSlide = $(itemContentList).find('.slide')[0];

          // Remove active
          $('.engage .color-grid .item.item-bdr').removeClass('active');
          // Set active
          $(item).addClass('active');
          // Remove active
          $('.engage .ftrs .cards .lst').removeClass('active');

          // Set active
          $(itemCardsList).addClass('active');

          // Apply / remove class to active children
          if ($(itemCardsList).children().length === 0) {
            $('.engage .ftrs .cards').addClass('-no-bb')
          } else {
            $('.engage .ftrs .cards').removeClass('-no-bb')
          }

          // Get first item
          let firstCard = $('.engage .ftrs .cards .lst.active li')[0];

          // Set active
          $('.engage .ftrs .cards .lst li').removeClass('active');
          $(firstCard).addClass('active');
          $('.engage .ftrs .content .lst .slide').removeClass('active');
          $(firstSlide).addClass('active');
          $('.engage .ftrs .content .lst').removeClass('active');
          $(itemContentList).addClass('active');

          // Get offset top
          let oft = $('.engage .ftrs .ftrs-cnt').offset().top;
          // Go to variable
          let gtt = oft - parseInt($('.top').outerHeight()) - 70;

          // Scroll to top
          $('html, body').animate({ scrollTop: gtt }, 'fast', 'easeInOutQuart');
        }
      });

      // Attach
      $('.engage .ftrs .cards .lst li').on('click', (e) => {
        // Object
        let card = $(e.currentTarget);
        // Active
        if (!$(card).hasClass('active')) {
          // Get index
          let activeCardListIndex = $(card).parents('.lst').index('.engage .ftrs .cards .lst');

          // Is active?
          if ($($('.engage .color-grid .item.item-bdr')[activeCardListIndex]).hasClass('active')) {
            // Remove active
            $('.engage .ftrs .cards .lst.active li').removeClass('active');
            // Set active
            $(card).addClass('active');
            // Get index
            let activeCardIndex = $('.engage .ftrs .cards .lst.active li').index(card);
            // Get active slide
            let activeSlide = $('.engage .ftrs .content .lst.active .slide')[activeCardIndex];
            // Remove active
            $('.engage .ftrs .content .lst .slide').removeClass('active');

            // Set active
            $(activeSlide).addClass('active');
          }
        }
      });

      // Attach
      $('.engage-m .color-grid .item').on('click', (e) => {
        // Object
        let item = $(e.currentTarget);

        // Active?
        if (!$(item).hasClass('active')) {
          // Set active
          $(item).addClass('active');
          // Get siblings
          let cards = $(item).siblings('.cards');

          // Slide down
          $(cards).slideDown({
            start: function () {
              $(this).css('display', 'flex');
            },
            done: function () {
              $(this).addClass('active');
            }
          });
        } else {
          // Remove active
          $(item).removeClass('active');
          // Get siblings
          let cards = $(item).siblings('.cards');

          // Slide down
          $(cards).slideUp({
            done: function () {
              $(this).removeClass('active');
            }
          });
        }
      });
    }
  };
}();

// Attach
$(document).ready(function () { colorgrid.initialize(); });

/* Use Cases
---------------------------------------------------------------- */

var useCase = function () {
  return {
    initialize: function () {
      // Use?
      if ($('.use-case').length > 0) {
        // Timed
        setTimeout(() => {
          // Heights array
          let heights = [];
          // Remove
          $('.use-case .use-case-cnt .box .inn').removeClass('hidden');
          // Get heighest
          for (let i = 0; i < $('.use-case .use-case-cnt .box .inn').length; i++) {
            heights.push($($('.use-case .use-case-cnt .box .inn')[i]).outerHeight())
          }

          // Max variable
          let maxHeight = 0;

          // Find heighest
          for (let i = 0; i < heights.length; i++) {
            if (maxHeight < heights[i]) {
              maxHeight = heights[i];
            }
          }

          // Set
          $('.use-case .use-case-cnt .box .inn').css("height", maxHeight + 'px');
          $('.use-case .use-case-cnt .box .inn').addClass('hidden');
          $($('.use-case .use-case-cnt .box .inn')[0]).removeClass('hidden');
          $($('.use-case .use-case-cnt .box .inn')[0]).removeClass('hidden-left');

          // Window resize
          $(window).on('resize', (e) => {
            // Height array
            let heights = [];
            // Active item
            let actualSlide = $('.use-case .use-case-cnt .nav.-desktop .item.selected');
            // Get relation
            let rel = $(actualSlide)[0].dataset.rel;
            // Set and reset
            $('.use-case .use-case-cnt .box .inn').css("height", `auto`);
            $('.use-case .use-case-cnt .box .inn').removeClass('hidden');

            // Get heighest
            for (let i = 0; i < $('.use-case .use-case-cnt .box .inn').length; i++) {
              heights.push($($('.use-case .use-case-cnt .box .inn')[i]).outerHeight())
            }

            // Max height
            let maxHeight = 0;

            // Find heighest
            for (let i = 0; i < heights.length; i++) {
              if (maxHeight < heights[i]) {
                maxHeight = heights[i];
              }
            }

            // Set height
            $('.use-case .use-case-cnt .box .inn').css("height", maxHeight + 'px');
            $('.use-case .use-case-cnt .box .inn').addClass('hidden');

            // Get object
            let inns = $('.use-case .use-case-cnt .box .inn');

            // Reset
            for (let i = 0; i < inns.length; i++) {
              if (inns[i].dataset.rel == rel) {
                $(inns[i]).removeClass('hidden');
                $(inns[i]).removeClass('hidden-left');
              }
            }

          });

          // Item click
          $('.use-case .use-case-cnt .nav.-desktop .item').on('click', (e) => {
            // Object
            let btnUse = $(e.currentTarget);

            // If not selected
            if (!$(btnUse).hasClass('selected')) {
              // Get item
              let beforeItem = $('.use-case .use-case-cnt .nav.-desktop .item.selected');
              // Get relation
              let relX = $(beforeItem)[0].dataset.rel;
              // Reset
              $('.use-case .use-case-cnt .nav.-desktop .item').removeClass('selected');

              // Set selected
              $(btnUse).addClass('selected');

              // Get index and relation
              let indexClicked = $('.use-case .use-case-cnt .nav.-desktop .item').index(btnUse);
              let rel = $(btnUse)[0].dataset.rel;

              // Remove selected, add selected
              $('.use-case .use-case-cnt .nav.-mobile .item').removeClass('selected');
              $('.use-case .use-case-cnt .nav.-mobile .item[data-rel=' + rel + ']').addClass('selected');

              // Get object
              let inns = $('.use-case .use-case-cnt .box .inn');

              // Loop items
              for (let i = 0; i < inns.length; i++) {
                // Reset
                $(inns[i]).removeClass('hidden');
                $(inns[i]).removeClass('hidden-left');

                // Get active object, set "hidden"
                if ($('.use-case .use-case-cnt .nav.-desktop .item').index($('.use-case .use-case-cnt .nav.-desktop .item[data-rel=' + inns[i].dataset.rel + ']')) < indexClicked) {
                  $(inns[i]).addClass('hidden-left');
                } else {
                  $(inns[i]).addClass('hidden');
                }

                // If same object, remove "hidden"
                if (inns[i].dataset.rel == rel) {
                  $(inns[i]).removeClass('hidden');
                  $(inns[i]).removeClass('hidden-left');
                }

                // Match?
                if (inns[i].dataset.rel == relX) {
                  // Show / hide items
                  if ($('.use-case .use-case-cnt .nav.-desktop .item').index($('.use-case .use-case-cnt .nav.-desktop .item[data-rel=' + inns[i].dataset.rel + ']')) < indexClicked) {
                    $(inns[i]).removeClass('hidden');
                    $(inns[i]).removeClass('hidden-left');
                    $(inns[i]).addClass('out-left');

                    // Timed
                    setTimeout(() => {
                      $(inns[i]).addClass('hidden-left');
                      $(inns[i]).removeClass('out-left');

                    }, 400);

                  } else {
                    $(inns[i]).removeClass('hidden');
                    $(inns[i]).removeClass('hidden-left');
                    $(inns[i]).addClass('out-right');

                    // Timed
                    setTimeout(() => {
                      $(inns[i]).addClass('hidden');
                      $(inns[i]).removeClass('out-right');
                    }, 400);
                  }
                }
              }
            }
          });

          // Item click
          $('.use-case .use-case-cnt .nav.-mobile .item').on('click', (e) => {
            // Object
            let btnUse = $(e.currentTarget);
            // Selected?
            if (!$(btnUse).hasClass('selected')) {
              // Get selected item
              let beforeItem = $('.use-case .use-case-cnt .nav.-mobile .item.selected');
              let relX = $(beforeItem)[0].dataset.rel;
              // Reset
              $('.use-case .use-case-cnt .nav.-mobile .item').removeClass('selected');

              // Set selected
              $(btnUse).addClass('selected');
              // Get active item
              let indexClicked = $('.use-case .use-case-cnt .nav.-mobile .item').index(btnUse);
              let rel = $(btnUse)[0].dataset.rel;

              // Reset
              $('.use-case .use-case-cnt .nav.-desktop .item').removeClass('selected');
              $('.use-case .use-case-cnt .nav.-desktop .item[data-rel=' + rel + ']').addClass('selected');
              $('.use-case .use-case-cnt .box .inn').addClass('hidden');

              // Get object
              let inns = $('.use-case .use-case-cnt .box .inn');

              // Loop items
              for (let i = 0; i < inns.length; i++) {
                // Set "hidden"
                $(inns[i]).removeClass('hidden');
                $(inns[i]).removeClass('hidden-left');

                // Set "hidden" items
                if ($('.use-case .use-case-cnt .nav.-mobile .item').index($('.use-case .use-case-cnt .nav.-mobile .item[data-rel=' + inns[i].dataset.rel + ']')) < indexClicked) {
                  $(inns[i]).addClass('hidden-left');
                } else {
                  $(inns[i]).addClass('hidden');
                }

                // If selected, unhide
                if (inns[i].dataset.rel == rel) {
                  $(inns[i]).removeClass('hidden');
                  $(inns[i]).removeClass('hidden-left');
                }

                // If not selected, set "hidden" toggle
                if (inns[i].dataset.rel == relX) {
                  if ($('.use-case .use-case-cnt .nav.-mobile .item').index($('.use-case .use-case-cnt .nav.-mobile .item[data-rel=' + inns[i].dataset.rel + ']')) < indexClicked) {
                    $(inns[i]).removeClass('hidden');
                    $(inns[i]).removeClass('hidden-left');
                    $(inns[i]).addClass('out-left');

                    // Timed
                    setTimeout(() => {
                      $(inns[i]).addClass('hidden-left');
                      $(inns[i]).removeClass('out-left');
                    }, 400);
                  } else {
                    $(inns[i]).removeClass('hidden');
                    $(inns[i]).removeClass('hidden-left');
                    $(inns[i]).addClass('out-right');

                    // Timed
                    setTimeout(() => {
                      $(inns[i]).addClass('hidden');
                      $(inns[i]).removeClass('out-right');
                    }, 400);
                  }
                }
              }
            }
          });
        }, 3000);
      }
    }
  };
}();

// Attach
$(document).ready(function () { useCase.initialize(); });

/* FAQ
---------------------------------------------------------------- */
var faq = function () {
  return {
    initialize: function () {
      // Attach
      $(".faq .acc .item .item-top").on('click', (e) => {
        // Set object
        let item = $(e.currentTarget).parents('.item');
        // If not active
        if (!$(item).hasClass('active')) {
          // Reset
          $(".faq .acc .item").removeClass('active');
          $(".faq .acc .item .txt").slideUp({
            done: () => {
              $(".faq .acc .item:not(.active)").removeClass('active');
            }
          });

          $(item).find('.txt').slideDown({
            start: () => {
              $(item).addClass('active');
            }
          });
        } else {
          // Set active
          $(".faq .acc .item .txt").slideUp({
            done: () => {
              $(".faq .acc .item").removeClass('active');
            }
          });
        }
      });
    }
  };
}();

// Attach
$(document).ready(function () { faq.initialize(); });

/* Pricing
---------------------------------------------------------------- */
var pricing = function () {
  return {
    initialize: function () {

      // Show / hide
      if ($('.anmo-btn.monthly').hasClass('active')) {
        $('.ann-opt').hide();
        $('.mon-opt').fadeIn();
      } else {
        $('.mon-opt').hide();
        $('.ann-opt').fadeIn();
      }

      // Button click
      $('.anmo-btn').on('click', (e) => {
        // Object
        let button = $(e.currentTarget);

        // Reset, set active
        $('.anmo-btn').removeClass('active');
        $(button).addClass('active');

        // Monthly?
        if ($(button).hasClass('monthly')) {
          // Fade out
          $('.ann-opt').fadeOut({
            start: function () {
              $(this).css({ 'position': 'absolute', 'top': 0 });
            },
            done: function () {
              $(this).css('position', 'static');
            }
          });

          // Fade in
          $('.mon-opt').fadeIn();
        } else {
          // Fade out
          $('.mon-opt').fadeOut({
            start: function () {
              $(this).css({ 'position': 'absolute', 'top': 0 });
            },
            done: function () {
              $(this).css('position', 'static');
            },
          });

          // Fade in
          $('.ann-opt').fadeIn();
        }
      });

      // Clone
      $(".prib .hobby").clone(true, true).appendTo(".pribmobile .hobby");
      $(".prib .smallbusiness").clone(true, true).appendTo(".pribmobile .smallbusiness");
      $(".prib .professional").clone(true, true).appendTo(".pribmobile .professional");
      $(".prib .enterprise").clone(true, true).appendTo(".pribmobile .enterprise");
    },
  };
}();

// Attach
$(document).ready(function () { pricing.initialize(); });

/* Choice box
---------------------------------------------------------------- */
var choicebox = {
  runok: false,
  initialize: function () {
    // Attach
    $('.choice-btn').on('click', function () { choicebox.show(this); });

    // Any lottie?
    if($('.lottieanimation').length){
      // Load file
      fileload.load('https://cdn.addevent.com/web/js/lottie/lottie.5.6.5.min.js', 'js');
      let self = this;
      // Call when script has loaded
      let bodyint = setInterval(function () {
        // Find out if "slick" exists
        if (typeof bodymovin !== 'undefined') {
          // Set
          self.runok = true;
          // Clear interval
          clearInterval(bodyint);
        }
      }, 500);
    }
  },
  show: function (f) {
    // Get target
    let obj = $(f);
    // Get selected option
    let opt = $(obj).attr('data-rela');
    // Source
    let src = $('.' + opt).attr('data-source');
    let fid = $('.' + opt).attr('id');

    // Reset
    $('#' + fid).html('');

    if (this.runok) {
      // Load animation
      bodymovin.loadAnimation({
        container: document.getElementById(fid),
        path: 'https://cdn.addevent.com/web/js/lottie/json/' + src,
        renderer: 'svg',
        loop: true,
        autoplay: true
      });
    }

    // Selected or not?
    if (!$(obj).hasClass('selected')) {
      // Reset
      $('.choice-btn').removeClass('selected');

      // Set selected
      $(obj).addClass('selected');

      // Get object
      let choiceIndex = $('.choice-btn').index(obj);

      // Get index
      if (choiceIndex >= 2) {
        choiceIndex = choiceIndex % 2;
      }

      // Apply
      $('.choice .right').addClass('hidden');
      $($('.choice .right')[choiceIndex]).removeClass('hidden');
      $('.choice-btns-m .choice-btn').removeClass('selected');
      $($('.choice-btns-m .choice-btn')[choiceIndex]).addClass('selected');
      $('.left .choice-btn').removeClass('selected');
      $($('.left .choice-btn')[choiceIndex]).addClass('selected');
    }

    // Toggle
    if ($(obj).hasClass('-purple')) {
      $('.choice-cnt').removeClass('-pink');
      $('.choice-cnt').addClass('-purple');
    } else {
      $('.choice-cnt').removeClass('-purple');
      $('.choice-cnt').addClass('-pink');
    }
  }
};

// Attach
$(document).ready(function () { choicebox.initialize(); });

/* Search clear
---------------------------------------------------------- */
var searchClear = function () {
  return {
    initialize: function () {
      // Show / hide close
      $('.search-box.-clearable .search-inp').keyup((e) => {
        if ($(e.currentTarget).val().length !== 0) {
          $(e.currentTarget).siblings('i').show();
        } else {
          $(e.currentTarget).siblings('i').hide();
        }
      });

      // Reset search box
      $('.search-box.-clearable i').on('click', (e) => {
        $(e.currentTarget).siblings('.search-inp').val('').focus();
        $(e.currentTarget).hide();
      });
    },
  };
}();

// Attach
$(document).ready(function () { searchClear.initialize(); });

/* Breadcrumb
---------------------------------------------------------- */
/* Breadcrumbs cut */
var bcCut = function () {
  return {
    initialize: function () {
      // Get object
      const breadcrumbs = $('.breadcrumbs .bc');

      // Loop items
      $.each(breadcrumbs, (index, item) => {
        // If more than x characters
        if ($(item).text().length > 13) {
          // Slice
          $(item).text($(item).text().slice(0, 13) + '...');
        }
      });
    }
  };
}();

// Attach
$(document).ready(function () { bcCut.initialize(); });

/* Developer menu
---------------------------------------------------------- */
var menuOpen = function () {
  return {
    initialize: function () {
      // Window scroll?
      if ($(window).scrollTop() > 0) {
        $('.left .fixed-box').addClass('-scroll');
      } else {
        $('.left .fixed-box').removeClass('-scroll');
      }

      // Attach to scroll
      $(window).on('scroll', () => {
        // Add scroll variable
        if ($(window).scrollTop() > 0) {
          $('.left .fixed-box').addClass('-scroll');
        } else {
          $('.left .fixed-box').removeClass('-scroll');
        }
      });

      // Height variable
      let height = 0;

      // Attach click
      $('.left .toggle-button').on('click', (e) => {
        // Get height
        let currentHeight = $('.left .hidden-box')[0].offsetHeight;

        // Heigher than current height?
        if (currentHeight > 0 && currentHeight > height) {
          height = currentHeight;
        }

        // Remove class and stop
        $('.left .hidden-box').removeClass('-start');
        $('.bg-op').stop();

        // Toggle open / close state
        if ($('.left .toggle-button').hasClass('-open')) {
          // Set
          $('.left .toggle-button').removeClass('-open');
          $('.left .toggle-button').text('Menu');
          $('.left .hidden-box').removeClass('-open');
          $('.left .hidden-box').css('height', `0px`);

          // Apply class?
          if ($(window).scrollTop() > 0) {
            $('.right .fixed-box').addClass('-scroll');
          }

          $('.bg-op').removeClass('-open');
          $('.bg-op').fadeOut();

          // Hide
          $('#moblftmnu').hide();
        } else {
          // Set
          $('.left .toggle-button').addClass('-open');
          $('.left .hidden-box').addClass('-open');
          $('.bg-op').addClass('-open');
          $('.bg-op').fadeIn();

          // Toggle height
          if (height > 0) {
            $('.left .hidden-box').css('height', height + 'px');
          } else {
            let xxx = $(' .left .hidden-box')[0].offsetHeight;
            $('.left .hidden-box').css('height', '0');
            $('.left .hidden-box').css('height', xxx + 'px');
          }

          setTimeout(() => {
            $('.left .hidden-box').css('height', 'auto');
          }, 320);

          // Apply scroll
          $('.left .fixed-box').removeClass('-scroll');
          $('.left .toggle-button').text('Close');

          // Show
          $('#moblftmnu').show();
        }
      });

      // Attach click
      $('.bg-op').on('click', (e) => {
        // Reset
        $('.left .toggle-button').removeClass('-open');
        $('.left .toggle-button').text('Menu');
        $('.left .hidden-box').removeClass('-open');
        $('.left .hidden-box').css('height', `0`);

        // If scroll?
        if ($(window).scrollTop() > 0) {
          $('.left .fixed-box').addClass('-scroll');
        }

        $('.bg-op').fadeOut();

        // Hide
        $('#moblftmnu').hide();
      });
    }
  };
}();

// Attach
$(document).ready(function () { menuOpen.initialize(); });

/* Slick prev/next visibility after init
---------------------------------------------------------------- */
var slickslide = function () {
  return {
    initialize: function () {
      // Load files
      if ($('.slick').length) {
        // Get
        fileload.load('https://cdn.addevent.com/web/css/slick/slick.1.8.1.v20211203.css', 'css');
        fileload.load('https://cdn.addevent.com/web/js/slick/slick.1.8.1.min.js', 'js');

        // Call when script has loaded
        let slickint = setInterval(function () {
          // Find out if "slick" exists
          if ($().slick) {
            // Call callback
            slickslide.callback();

            // Clear interval
            clearInterval(slickint);
          }
        }, 500);
      }
    },
    callback: function () {
      // Attach
      if ($(".trs .opinion.slick")) {

        // Hide
        $('.trs .opinion.slick .box').css('visibility', 'hidden');
        $(".trs .opinion.slick").not('.slick-initialized').slick({
          infinite: true,
          slidesToShow: 2,
          slidesToScroll: 2,
          autoplay: false,
          autoplaySpeed: 10000,
          arrows: false,
          dots: true,
          pauseOnHover: true,
          cssEase: 'ease',
          centerMode: false,
          responsive: [{
            breakpoint: 800,
            settings: {
              slidesToShow: 1,
              slidesToScroll: 1
            }
          }, {
            breakpoint: 420,
            settings: {
              slidesToShow: 1,
              slidesToScroll: 1
            }
          }]
        });

        // Show
        $('.trs .opinion.slick .box').css('visibility', 'visible');
      }

      // Attach
      if ($(".learn.slick")) {
        $(".learn.slick .color-grid").not('.slick-initialized').slick({
          infinite: true,
          dots: true,
          arrows: false,
          centerMode: true,
          centerPadding: '12px'
        });
      }

      // Attach
      if ($(".mobile-pricing-slick")) {
        $(".mobile-pricing-slick").not('.slick-initialized').slick({
          infinite: true,
          dots: true,
          arrows: false,
          slidesToShow: 1,
          //centerMode: true,
          //centerPadding: '24px 0 8px'
        });
      }

      /* Pricing */
      $('.mobile-pricing-slick').on('init', (e, slick) => {
        $(slick.$slides[0]).prev().css('opacity', 0);
      });

      // Touch start
      $('.mobile-pricing-slick').on('mousedown touchstart', (e) => {
        $('.mobile-pricing-slick .slick-slide').animate({
          'opacity': 1
        }, 400);
      });

      // After change
      $('.mobile-pricing-slick').on('afterChange', (e, slick, currentSlide) => {
        $(slick.$slides[currentSlide]).prev().animate({
          'opacity': 0
        }, 200);
      });

      // Attach
      $('.opinion.slick').on('mousedown touchstart', (e) => {
        if ($('.slick-current').is($(".slick-slide:not(.slick-cloned)").first())) {
          $('.slick-current').prevAll().first().addClass('-bs');
        } else if ($('.slick-current').is($(".slick-slide:not(.slick-cloned)").last())) {
          $('.slick-current').nextAll().first().addClass('-bs');
        }
      });

      // Attach
      $('.opinion.slick').on('mouseup touchend', (e) => {
        $('.slick-current').prevAll().first().removeClass('-bs');
        $('.slick-current').nextAll().first().removeClass('-bs');
      });

      /* Pricing */
      $('.mobile-pricing-slick').on('mousedown touchstart', (e) => {
        if ($('.slick-current').is($(".slick-slide:not(.slick-cloned)").first())) {
          $('.slick-current').prevAll().first().addClass('-bs');
        } else if ($('.slick-current').is($(".slick-slide:not(.slick-cloned)").last())) {
          $('.slick-current').nextAll().first().addClass('-bs');
        }
      });

      // Attach
      $('.mobile-pricing-slick').on('mouseup touchend', (e) => {
        $('.slick-current').prevAll().first().removeClass('-bs');
        $('.slick-current').nextAll().first().removeClass('-bs');
      });

      /* Learn */
      $('.learn.slick').on('mousedown touchstart', (e) => {
        if ($('.slick-current').is($(".slick-slide:not(.slick-cloned)").first())) {
          $('.slick-current').prevAll().first().addClass('-bs');
        } else if ($('.slick-current').is($(".slick-slide:not(.slick-cloned)").last())) {
          $('.slick-current').nextAll().first().addClass('-bs');
        }
      });

      $('.learn.slick').on('mouseup touchend', (e) => {
        $('.slick-current').prevAll().first().removeClass('-bs');
        $('.slick-current').nextAll().first().removeClass('-bs');
      });

      // Frontpage logo carousel?
      if ($('.logo-carousel').length) {

        // Run
        $('.logo-carousel').slick({
          rows: 1,
          slidesToShow: 4,
          slidesToScroll: 4,
          autoplay: true,
          autoplaySpeed: 2500,
          arrows: false,
          dots: false,
          pauseOnHover: false,
          cssEase: 'ease',
          centerMode: false,
          slidesPerRow: 1,
          responsive: [{
            breakpoint: 940,
            settings: {
              slidesToShow: 3,
              slidesToScroll: 3
            }
          }, {
            breakpoint: 640,
            settings: {
              slidesToShow: 2,
              slidesToScroll: 2
            }
          }, {
            breakpoint: 420,
            settings: {
              slidesToShow: 1,
              slidesToScroll: 1
            }
          }]
        });

        // Show
        $('.logo-carousel .slide div').css('visibility', 'visible');

      }

    }
  };
}();

// Attach
$(document).ready(function () {
  if ($('.slick').length) { slickslide.initialize(); }
});

/* Misc loader and more
---------------------------------------------------------------- */

var miscload = function () {
  return {
    initialize: function () {

      // Load
      if ($('.addeventatc').length) {

        // Get
        fileload.load('https://cdn.addevent.com/libs/atc/1.6.1/atc.min.js', 'js');

      }

      // Load
      if ($('.addeventstc').length) {
        // Get
        fileload.load('https://cdn.addevent.com/libs/stc/1.0.2/stc.min.js', 'js');
      }

      // Blog links (used in articles overview)
      // Any blog items
      if ($('.blogitem').length) {
        // Attach
        $('.blogitem').on('click', function () {
          // Go to
          location.href = $(this).attr('data-link');
        });
      }

      // Preload images
      $(document.body).append('<div class="preload" style="position:absolute;left:-10000px;top:-10000px;"><img src="https://cdn.addevent.com/web/images/icon-check-fff-t2.svg" width="24" height="24" alt="" loading="lazy" /><img src="https://cdn.addevent.com/web/images/icon-load-t1.svg" width="26" height="26" alt="" loading="lazy" /><img src="https://cdn.addevent.com/web/images/homepage_hero_1.svg" width="570" height="503" alt="" loading="lazy" /><img src="https://cdn.addevent.com/web/images/homepage_hero_2.svg" width="570" height="503" alt="" loading="lazy" /><img src="https://cdn.addevent.com/web/images/homepage_hero_3.svg" width="570" height="503" alt="" loading="lazy" /><img src="https://cdn.addevent.com/web/images/homepage_hero_4.svg" width="570" height="503" alt="" loading="lazy" /><img src="https://cdn.addevent.com/web/images/homepage_hero_5.svg" width="570" height="503" alt="" loading="lazy" /><img src="https://cdn.addevent.com/web/images/tooltip-arrows-t1.svg" width="50" height="50" alt="" loading="lazy" /></div>');

    }
  };
}();

// Attach
$(document).ready(function () { miscload.initialize(); });

/* Pricing tooltip
---------------------------------------------------------------- */
var prictooltip = function () {
  let prielm = null;

  return {
    initialize: function () {

      // Append
      $('.icon-tooltip').on('mouseover', function () { prictooltip.show(this); });
      $('.icon-tooltip').on('mouseout', function () { prictooltip.hide(this); });

    },
    show: function (f) {

      // Get parent
      var par = $(f).closest('.rl');

      // Get element
      prielm = $(par).find('.tooltip');

      // Show
      $(prielm).show();

      // Get top
      var tt = parseInt($(f).position().top);

      // Get height
      var hh = $(par).find('.tooltip').outerHeight();

      // Adjust top
      $(par).find('.tooltip').css('top', (tt - hh - 15) + 'px');

    },
    hide: function (f) {

      // Hide
      $(prielm).hide();

    }
  };
}();

/* Attach */
$(document).ready(function () { prictooltip.initialize(); });

/* Notificator
---------------------------------------------------------------- */

var notificator = function () {

  // Timer
  var timer, extratimer;

  return {
    show: function (txt, end) {

      // Build notificator
      notificator.build();

      // Add to queue
      $('#notificator').queue('notificator', function () {

        // Show
        $('#notificator').show();

        // Update text
        $('#notificator-text').html(txt);

        // Close
        if (end) {

          // Add class
          $('#notificator .load').addClass('saved');

          // Clear timeout
          clearTimeout(timer);

          // Delay
          timer = setTimeout(function () {

            // Hide
            notificator.hide();

          }, 2000);

        } else {

          // Remove class
          $('#notificator .load').removeClass('saved');

        }

        // Clear timeout
        clearTimeout(extratimer);

        // Delay
        extratimer = setTimeout(function () {

          // Hide
          notificator.hide();

        }, 15000);

      }).dequeue('notificator');

    },
    hide: function () {

      // Hide
      $('#notificator').fadeOut('fast');

      // Clear timers
      clearTimeout(timer);
      clearTimeout(extratimer);

    },
    break: function () {
      // Dequeue
      $('#notificator').dequeue('notificator');
      // Clear timeout
      clearTimeout(extratimer);
      // Delay
      extratimer = setTimeout(function () {
        // Hide
        notificator.hide();
      }, 800);
    },
    build: function (f) {
      // Get object
      const obj = document.getElementById('notificator');
      // Set variable
      let html = '';

      // .nav-t1 user context
      if (!obj) {
        // Set
        html += '<div class="noti-t1" id="notificator">';
        html += '	<div class="inn">';
        html += '		<div id="notificator-text"></div>';
        html += '		<div class="load"></div>';
        html += '	</div>';
        html += '</div>';

        // Append
        $("body").append(html);
      }
    }
  };
}();

/* Copy code
---------------------------------------------------------------- */

var copycodex = function () {
  return {
    initialize: function () {
      // Append
      $('.copycodex').on('click', function () { copycodex.copy(this); });
      $('.copydivx').on('click', function () { copycodex.copydiv(this); });
    },
    copy: function (f) {

      // If the copy container doesn't exists, then add it
      if (!$('#tmpcopywrp').length) {

        // Append
        $('body').append('<div id="tmpcopywrp"><textarea id="tmpcopytext"></textarea></div>');

      }

      // Get relation
      var rel = $(f).attr('data-copy-rel');

      // Get content
      var ctx = $('#' + rel).text();

      // Remove breaks
      ctx = ctx.replace(/(\r\n|\n|\r)/gm, "").trim();

      // Transfer to textarea
      $('#tmpcopytext').val(ctx);

      // Get text area
      var con = document.getElementById(rel);

      // Select content
      $('#tmpcopytext').select();

      // Copy
      document.execCommand('copy');

      // Notify
      notificator.show('Copied', true);

    },
    copydiv: function (f) {

      // Get relation
      var rel = $(f).attr('data-copy-rel');
      var cem = $(f).attr('data-copy-snippet');

      // Any snippet to parse?
      if (cem != '' && typeof cem !== "undefined") {

        // Run
        copycodex.snippets(rel, cem);

      }

      // Delete if exists
      if ($('#copycat').length) {
        $('#copycat').remove();
      }

      // Get content
      var con = $('#' + rel).html();

      // Add
      $('body').append('<div id="copycat" style="position:fixed;left:-10000px;top:0px;z-index:9999999;">' + con + '</div>');

      // Timed
      setTimeout(function () {

        // Copy
        var doc = document, text = doc.getElementById('copycat'), range, selection;
        if (doc.body.createTextRange) {
          range = doc.body.createTextRange();
          range.moveToElementText(text);
          range.select();
          document.execCommand("copy");
        } else if (window.getSelection) {
          selection = window.getSelection();
          range = doc.createRange();
          range.selectNodeContents(text);
          selection.removeAllRanges();
          selection.addRange(range);
          document.execCommand("copy");
        }

      }, 400);

      // Notify
      notificator.show('Copied', true);


    },
    snippets: function (rel, snip) {

      // Variables
      var html = '';

      // HTML snippet
      if (snip == 'add-to-calendar-links') {

        // Set
        html = '<br /><br /><p style="margin:0px 0px 10px 0px;text-align:center;font-size:17px;line-height:150%;color:#000;font-weight:bold;">Add event to calendar</p> <p style="margin:0px 0px 10px 0px;text-align:center;"><a href="https://www.addevent.com/event/vA8984410+apple" title="Apple" target="_blank" style="display:inline;"><img src="https://cdn.addevent.com/web/images/icon-emd-share-apple-t1.png" alt="Apple" width="45" border="0" style="width:45px;display:inline;"></a> <a href="https://www.addevent.com/event/vA8984410+google" title="Google" target="_blank" style="display:inline;"><img src="https://cdn.addevent.com/web/images/icon-emd-share-google-t1.png" alt="Google" width="45" border="0" style="width:45px;display:inline;"></a> <a href="https://www.addevent.com/event/vA8984410+office365" title="Office 365" target="_blank" style="display:inline;"><img src="https://cdn.addevent.com/web/images/icon-emd-share-office365-t1.png" alt="Office 365" width="45" border="0" style="width:45px;display:inline;"></a> <a href="https://www.addevent.com/event/vA8984410+outlook" title="Outlook" target="_blank" style="display:inline;"><img src="https://cdn.addevent.com/web/images/icon-emd-share-outlook-t1.png" alt="Outlook" width="45" border="0" style="width:45px;display:inline;"></a> <a href="https://www.addevent.com/event/vA8984410+outlookcom" title="Outlook.com" target="_blank" style="display:inline;"><img src="https://cdn.addevent.com/web/images/icon-emd-share-outlookcom-t1.png" alt="Outlook.com" width="45" border="0" style="width:45px;display:inline;"></a> <a href="https://www.addevent.com/event/vA8984410+yahoo" title="Yahoo" target="_blank" style="display:inline;"><img src="https://cdn.addevent.com/web/images/icon-emd-share-yahoo-t1.png" alt="Yahoo" width="45" border="0" style="width:45px;display:inline;"></a></p><br /><p style="margin:0px 0px 10px 0px;text-align:center;font-size:17px;line-height:150%;color:#000;font-weight:bold;">Add event to calendar</p> <p style="margin:0px 0px 10px 0px;text-align:center;"><a href="https://www.addevent.com/event/vA8984410+apple" title="" target="_blank" style="color:#125ef8;text-decoration:underline;">Apple</a> &nbsp; <a href="https://www.addevent.com/event/vA8984410+google" title="" target="_blank" style="color:#125ef8;text-decoration:underline;">Google</a> &nbsp; <a href="https://www.addevent.com/event/vA8984410+outlook" title="" target="_blank" style="color:#125ef8;text-decoration:underline;">Outlook</a> &nbsp; <a href="https://www.addevent.com/event/vA8984410+outlookcom" title="" target="_blank" style="color:#125ef8;text-decoration:underline;">Outlook.com</a> &nbsp; <a href="https://www.addevent.com/event/vA8984410+office365" title="" target="_blank" style="color:#125ef8;text-decoration:underline;">Office 365</a> &nbsp; <a href="https://www.addevent.com/event/vA8984410+yahoo" title="" target="_blank" style="color:#125ef8;text-decoration:underline;">Yahoo</a></p><br /><br />';

      } else if (snip == 'rsvp-links') {

        // Set
        html = '<br /><br />Attend our awesome event <br /><br /><a href="https://www.addevent.com/event/ty8688477" title="" target="_blank" style="display:inline-block;font-size:16px;font-weight:bold;background:#125ef8;color:#ffffff;line-height:42px;padding:0px 15px;border-radius:2px;">RSVP</a><br /><br />';

      } else if (snip == 'subscribe-to-calendar-links') {

        // Set
        html = '<br /><br /><p style="margin:0px 0px 10px 0px;text-align:center;font-size:17px;line-height:150%;color:#000;font-weight:bold;">Add event to calendar</p> <p style="margin:0px 0px 10px 0px;text-align:center;"><a href="https://www.addevent.com/calendar/ih348885+apple" title="Apple" target="_blank" style="display:inline;"><img src="https://cdn.addevent.com/web/images/icon-emd-share-apple-t1.png" alt="Apple" width="45" border="0" style="width:45px;display:inline;"></a> <a href="https://www.addevent.com/calendar/ih348885+google" title="Google" target="_blank" style="display:inline;"><img src="https://cdn.addevent.com/web/images/icon-emd-share-google-t1.png" alt="Google" width="45" border="0" style="width:45px;display:inline;"></a> <a href="https://www.addevent.com/calendar/ih348885+office365" title="Office 365" target="_blank" style="display:inline;"><img src="https://cdn.addevent.com/web/images/icon-emd-share-office365-t1.png" alt="Office 365" width="45" border="0" style="width:45px;display:inline;"></a> <a href="https://www.addevent.com/calendar/ih348885+outlook" title="Outlook" target="_blank" style="display:inline;"><img src="https://cdn.addevent.com/web/images/icon-emd-share-outlook-t1.png" alt="Outlook" width="45" border="0" style="width:45px;display:inline;"></a> <a href="https://www.addevent.com/calendar/ih348885+outlookcom" title="Outlook.com" target="_blank" style="display:inline;"><img src="https://cdn.addevent.com/web/images/icon-emd-share-outlookcom-t1.png" alt="Outlook.com" width="45" border="0" style="width:45px;display:inline;"></a> <a href="https://www.addevent.com/calendar/ih348885+yahoo" title="Yahoo" target="_blank" style="display:inline;"><img src="https://cdn.addevent.com/web/images/icon-emd-share-yahoo-t1.png" alt="Yahoo" width="45" border="0" style="width:45px;display:inline;"></a></p><br /><p style="margin:0px 0px 10px 0px;text-align:center;font-size:17px;line-height:150%;color:#000;font-weight:bold;">Add event to calendar</p> <p style="margin:0px 0px 10px 0px;text-align:center;"><a href="https://www.addevent.com/calendar/ih348885+apple" title="" target="_blank" style="color:#125ef8;text-decoration:underline;">Apple</a> &nbsp; <a href="https://www.addevent.com/calendar/ih348885+google" title="" target="_blank" style="color:#125ef8;text-decoration:underline;">Google</a> &nbsp; <a href="https://www.addevent.com/calendar/ih348885+outlook" title="" target="_blank" style="color:#125ef8;text-decoration:underline;">Outlook</a> &nbsp; <a href="https://www.addevent.com/calendar/ih348885+outlookcom" title="" target="_blank" style="color:#125ef8;text-decoration:underline;">Outlook.com</a> &nbsp; <a href="https://www.addevent.com/calendar/ih348885+office365" title="" target="_blank" style="color:#125ef8;text-decoration:underline;">Office 365</a> &nbsp; <a href="https://www.addevent.com/calendar/ih348885+yahoo" title="" target="_blank" style="color:#125ef8;text-decoration:underline;">Yahoo</a></p><br /><br />';

      }

      // Parse
      $('#' + rel).html(html);

    }
  };
}();

/* Attach */
$(document).ready(function () { copycodex.initialize(); });

/* Dev menu
----------------------------------------------------------*/

var devmenu = function () {
  return {
    initialize: function () {

      $('.dev-cnt .left .list .dev-arr').on('click', e => {

        // Object
        const target = $(e.currentTarget);

        // Toggle active
        if (!$(target).parents('li').hasClass('active')) {

          // Reset
          $('.dev-cnt .left .list li').removeClass('active');

          // Set active
          $(target).parents('li').addClass('active');

          // Slidedown
          $(target).siblings('.sublist').slideDown(function () {
            $(this).addClass('active');
          });

          // Slide up
          $('.dev-cnt .left .list li:not(.active) .sublist').slideUp();

        } else {

          // Reset
          $('.dev-cnt .left .list li').removeClass('active');
          $('.dev-cnt .left .list li .sublist').slideUp();

        }

      });

      // Attach
      $('.dev-cnt .left.-mobile .sublist li a').on('click', () => {

        // Remove / reset
        $(' .left .toggle-button').removeClass('-open');
        $(' .left .toggle-button').text('Menu');
        $(' .left .hidden-box').removeClass('-open');
        $(' .left .hidden-box').css('height', `0px`);

        // Attach scroll
        if ($(window).scrollTop() > 0) {
          $(' .right .fixed-box').addClass('-scroll');
        }

        $('.bg-op').removeClass('-open');
        $('.bg-op').fadeOut();
        document.body.style.overflow = "auto";
        document.body.style.height = "auto";

      });

    }
  };
}();

// Attach
$(document).ready(function () { devmenu.initialize(); });

/* Modals popup
---------------------------------------------------------------- */

var modals = function () {
  return {
    initialize: function (f) {

      // Attach
      $('.-openModal').on('click', function () { modals.show(this); return false; });

    },
    show: function (f) {

      // Remove container
      if ($('#modalbox').length) {

        // Remove
        $('body').find('#modalbox').remove();

      }

      // Get URL
      var ref = $(f).attr('href');

      // Variables
      var html = '';

      // HTML
      html += '<div class="modal -open" id="modalbox">';
      html += '    <div class="modal-box">';
      html += '        <i class="icon-close modal-close"></i>';
      html += '        <div class="iframe-box">';
      html += '            <iframe width="720" height="405" src="' + ref + '?wmode=opaque&autohide=1&autoplay=1&enablejsapi=1" title="" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe>';
      html += '        </div>';
      html += '    </div>';
      html += '</div>';

      // Add container
      $('body').append(html);

      // Attach
      $('#modalbox .modal-close').on('click', function () { modals.hide(); return false; });
      $('#modalbox').on('click', function (event) { event.stopPropagation(); });

      // Unbind
      $(document).unbind(".modalspopup");
      // Timed
      setTimeout(function () {
        // Bind
        $(document).on("click.modalspopup", function () { modals.hide(); });
      }, 200);
    },
    hide: function () {
      // Remove
      $('body').find('#modalbox').remove();
    }
  };
}();

// Attach
$(document).ready(function () { modals.initialize(); });

/* Contact form (sales)
---------------------------------------------------------------- */

const contactsalesform = {
  checktoggle: function (f) {
    // Get base
    let bas = $(f).closest('.hs-form-checkbox-display');

    // Checked?
    if ($(f).is(":checked")) {
      // Add
      $(bas).addClass('checked');
    } else {
      // Remove
      $(bas).removeClass('checked');
    }
  },
  formsubmit: function (f) {
    // Disable submit
    $('#form-contact-support .hs-submit .actions input').prop('disabled', true);
    $('#form-contact-support .hs-submit .actions input').addClass('disabled');

    // Notify
    notificator.show('Sending');
  },
  formsubmitted: function (f) {
    // Notify
    notificator.show('Sent', true);
    // Scroll to top
    window.scrollTo({ top: 0, behavior: 'smooth' });
  },
  populate: function () {
    // Attach
    $('#form-contact .hs-form-checkbox .hs-input').on('click', function () { contactsalesform.checktoggle(this); });
    // Get known field values, parse to Hubspot form
    $('#form-contact input[name="email"]').val($('#con_useremail').val());
    $('#form-contact input[name="TICKET.clientid"]').val($('#con_userclient').val());
    $('#form-contact input[name="TICKET.planname"]').val($('#con_userplan').val());

    // Timed
    setTimeout(function () {
      $('#form-contact').removeClass('loading');
    }, 400);
  }
};

/* Contact form (support)
---------------------------------------------------------------- */
var contactsupportform = {
  formsubmit: function (f) {
    // Disable submit
    $('#form-contact-support .hs-submit .actions input').prop('disabled', true);
    $('#form-contact-support .hs-submit .actions input').addClass('disabled');

    // Notify
    notificator.show('Sending');
  },
  formsubmitted: function (f) {
    // Notify
    notificator.show('Sent', true);
    // Scroll to top
    window.scrollTo({ top: 0, behavior: 'smooth' });
  },
  populate: function () {
    console.log('form populate');
    // Get known field values, parse to Hubspot form
    $('#form-contact-support input[name="email"]').val($('#con_useremail').val());
    $('#form-contact-support input[name="TICKET.clientid"]').val($('#con_userclient').val());
    $('#form-contact-support input[name="TICKET.planname"]').val($('#con_userplan').val());
    $('#form-contact-support input[name="TICKET.ticketarticle"]').val($('#con_article_title').val());
    $('#form-contact-support input[name="TICKET.article_link"]').val($('#con_article_link').val());

    // Focus
    setTimeout(function () {
      $('#form-contact-support input[name="email"]').trigger('focus');
    }, 800);

    // Timed
    setTimeout(function () {
      $('#form-contact-support').removeClass('loading');
    }, 400);
  }
};

/* Integrations search
---------------------------------------------------------------- */
var integrationsform = function () {
  return {
    initialize: function () {
      // Exists?
      if ($('.form-integrations').length) {
        // Attach
        $('.form-integrations').on('submit', function () { return integrationsform.validate(this); });
      }
    },
    validate: function (f) {
      // Execute
      let execute = true;
      // Validate
      if (!validate.empty(f.q.value)) {
        // Execute
        execute = false;
      }

      // Send or error?
      if (execute) {
        // Go to search page
        location.href = '/integrations/search/' + encodeURIComponent(f.q.value);
      }

      // Return
      return false;
    }
  };
}();

// Ready
$(document).ready(function () { integrationsform.initialize(); });

/* Frontpage: Syncs count
---------------------------------------------------------------- */

var cococount = function () {
  // Timers
  let mintimer, sectimer;

  return {
    initialize: function () {
      // Exists?
      if (document.getElementById('coco-count')) {
        // Call
        cococount.getnewsync();
      }
    },
    getnewsync: function () {
      // Ajax
      $.ajax({
        type: 'GET',
        url: '/misc/accounts-summary',
        cache: false,
        dataType: 'json',
        success: function (data) {
          // Clear interval
          clearInterval(sectimer);
          clearTimeout(mintimer);

          // Parse JSON
          const dat = data;
          // Base number
          let bas = dat.AccountsTotal;
          // Get start value
          let curstart = $('#coco-count').attr('data-start');
          // Count up number - get current minus some
          let cux = bas - 500;
          // Stored count?
          let cococook = cookies.read('cococount');

          // Any cookie value?
          if (cococook != '') {
            cux = cococook;
          }

          // Initial call?
          if (curstart == '') {
            // Set
            $('#coco-count').attr('data-start', cux);
            $('#coco-count').attr('data-current', cux);
            $('#coco-count').attr('data-end', bas);
          } else {
            // Set
            $('#coco-count').attr('data-end', bas);
          }

          // Call
          mintimer = setTimeout(function () { cococount.getnewsync(); }, 60000);
          // Call right away
          cococount.getnums();
          // Set timer
          sectimer = setInterval(function () {
            // Call
            cococount.getnums();
          }, 10000);
        }
      });
    },
    getnums: function () {
      // Get start / end
      let end = parseInt($('#coco-count').attr('data-end'));
      let cur = parseInt($('#coco-count').attr('data-current'));
      // Random number between 2 and 5
      let rnd = Math.floor(Math.random() * (5 - 2 + 1) + 2);
      // Next
      let next = cur + rnd;
      // Real next
      let rnext = null;
      // If real next is higher than actual top, then set top to actual.
      // Else add X number to current count
      if (next > end) {
        rnext = end;
      } else {
        rnext = next;
      }

      // Remember
      cookies.create('cococount', rnext, 10);
      // Timer
      let tstart = 200;
      // Set temporary current
      let curx = cur;

      // Loop from -> to
      for (let i = cur; i < rnext; i++) {
        // Add to timer
        tstart = tstart + 200;

        // Timed count up with a timeout
        setTimeout(function () {
          // Add to current temporary counter
          curx++;
          // Format number
          let val = (curx).toLocaleString(undefined, { minimumFractionDigits: 0 });

          // Update text + current
          $('#coco-count').text(val);
          $('#coco-count').attr('data-current', curx);
        }, tstart);
      }

      // Is next is higher or equal to end, then show end
      if (rnext >= end) {
        // Format number
        let val = (rnext).toLocaleString(undefined, { minimumFractionDigits: 0 });

        // Update text + current
        $('#coco-count').text(val);
      }
    }
  };
}();

// Ready
$(document).ready(function () { cococount.initialize(); });



/* Custom templates editor
---------------------------------------------------------------- */

var cuteed = function () {
  return {
    initialize: function () {
      // Attach
      $('#cuteedvity a').on('click', function () { cuteed.cuteedvity(this); return false; });
    },
    cuteedvity: function (f) {
      if (!$(f).hasClass('disabled')) {
        // Get type
        let typ = $(f).attr('data-type');

        // Reset
        $('#cuteedvity a').removeClass('selected');

        // Set selected
        $(f).addClass('selected');

        // Manage class
        $('#cuteedvity-ctn').removeClass('desktop tablet mobile');

        // Set class
        $('#cuteedvity-ctn').addClass(typ);

      }

    }
  };
}();

/* Attach */
$(document).ready(function () { cuteed.initialize(); });

/* Read more
---------------------------------------------------------------- */

var readmore = function () {
  return {
    initialize: function () {
      // Attach
      $('.readmorelink').on('click', function () { readmore.show(this); return false; });
    },
    show: function (f) {
      // Get rel
      let rel = $(f).attr('data-rel');
      // Show
      $('#' + rel + '-txt').show();
      // Remove read more
      $(f).hide();
    }
  };
}();

// Attach
$(document).ready(function () { readmore.initialize(); });

/* RRule generator
---------------------------------------------------------------- */

var rrule = function () {
  // Global
  let timer = null;

  return {
    initialize: function () {
      // Attach
      $('#rrule-pop #interval').on('change', function () { rrule.interval(this); return false; });
      $('#rrule-pop #end').on('change', function () { rrule.end(this); return false; });
      $('#rrule-pop #weekdays ul li').on('click', function () { rrule.weekdaysday(this); return false; });
      $('#rrule-pop #interval-num').on('change blur keyup', function () { rrule.getrule(this); return false; });

      $('#rrule-pop #end-num-val').on('keydown change blur', function (e) {
        if (e.which == '8' || e.which == '46') {
          // Prevent default
          e.preventDefault();
          // Set to null
          e.target.value = '';
        } else {
          // Get rule timed
          setTimeout(function () {
            rrule.getrule(this);
          }, 200);
        }
      });

      $('#rrule-pop #interval-num').on('change blur', function (e) {
        if (e.target.value == '' || e.target.value == '0') {
          e.target.value = 1;
        }
      });

      $('#rrule-pop .rad1_month_inp_dy').on('change', function () { rrule.getrule(this); return false; });
      $('#rrule-pop .rad2_month_inp_po').on('change', function () { rrule.getrule(this); return false; });
      $('#rrule-pop .rad2_month_inp_dy').on('change', function () { rrule.getrule(this); return false; });
      $('#rrule-pop .rad1_year_inp_mo').on('change', function () { rrule.getrule(this); return false; });
      $('#rrule-pop .rad1_year_inp_dy').on('change', function () { rrule.getrule(this); return false; });
      $('#rrule-pop .rad2_year_inp_po').on('change', function () { rrule.getrule(this); return false; });
      $('#rrule-pop .rad2_year_inp_dy').on('change', function () { rrule.getrule(this); return false; });
      $('#rrule-pop .rad2_year_inp_mo').on('change', function () { rrule.getrule(this); return false; });
      $('#rrule-pop #check-year-rad1, #rrule-pop #check-year-rad2').on('click', function () { rrule.yearrad(this); return false; });
      $('#rrule-pop #check-month-rad1, #rrule-pop #check-month-rad2').on('click', function () { rrule.monthrad(this); return false; });
      $('#rrule-pop .readmore').on('click', function () { rrule.readmore(this); return false; });
      $('#rrule-pop .foot .save').on('click', function () { rrule.formsave(this); });
      $('#rrule-pop .foot .cancel, #rrule-pop .close').on('click', function () { rrule.formcancel(this); });

      // Date picker
      $("#end-date-val").datepicker({
        showWeek: true,
        firstDay: '1',
        dateFormat: 'M d, yy',
        autoclose: true,
        minDate: 0,
      }).on('change', function (e) {
        // Timed, get date
        setTimeout(function () {
          // Get start date
          let sda = $("#end-date-val").datepicker('getDate');
          // Get dates
          let sdaf = sda.getFullYear() + ('0' + (sda.getMonth() + 1)).slice(-2) + ("0" + sda.getDate()).slice(-2) + 'T235959';

          // Update
          $("#end-date-val").attr('data-date', sdaf);
          // Update
          rrule.getrule();
        }, 200);
      });

      // Convert date
      let d2 = new Date();
      // Add one month
      d2.setMonth(d2.getMonth() + 1);
      // Set new "to" date + set min date
      $('#end-date-val').datepicker("setDate", d2);
      // Date string attr
      let sdaf = d2.getFullYear() + ('0' + (d2.getMonth() + 1)).slice(-2) + ("0" + d2.getDate()).slice(-2) + 'T235959';

      // Update
      $("#end-date-val").attr('data-date', sdaf);
    },
    initsetup: function () {
      // Variables
      let freq = '';
      // Rule
      let str = $('#rrule_fin').val().toLowerCase();
      // Split
      let strarr = str.split(';');

      // Loop
      for (let i = 0; i < strarr.length; i++) {
        // Split values
        let itmarr = strarr[i].split('=');
        // Get values
        let rnam = itmarr[0];
        let rval = itmarr[1];

        // FREQ
        if (rnam == 'freq') { freq = rval; }
      }

      // Todays date variables
      let d = new Date();
      let now_month = d.getMonth() + 1;
      let now_date = d.getDate();
      let now_day = d.getDay(); // Sunday is 0, Monday is 1
      let now_day_lbl = 'MO';

      // Toggle today labels
      if (now_day == '0') {
        now_day_lbl = "SU";
      } else if (now_day == '1') {
        now_day_lbl = "MO";
      } else if (now_day == '2') {
        now_day_lbl = "TU";
      } else if (now_day == '3') {
        now_day_lbl = "WE";
      } else if (now_day == '4') {
        now_day_lbl = "TH";
      } else if (now_day == '5') {
        now_day_lbl = "FR";
      } else if (now_day == '6') {
        now_day_lbl = "SA";
      }

      // Set all defaults
      if (freq == '') {
        // Set defaults
        $('#weekdays .wkdys' + now_day_lbl.toLowerCase()).addClass('active');
        $('#check-month-rad1').addClass('selected');
        $('.rad1_month_inp_dy').val(now_date);
        $('.rad2_month_inp_po').val('1');
        $('.rad2_month_inp_dy').val(now_day_lbl);
        $('#check-year-rad1').addClass('selected');
        $('.rad1_year_inp_mo').val(now_month);
        $('.rad1_year_inp_dy').val(now_date);
        $('.rad2_year_inp_dy').val(now_day_lbl);
        $('.rad2_year_inp_mo').val(now_month);
      } else if (freq == 'daily') {
        // Set defaults
        $('#weekdays .wkdys' + now_day_lbl.toLowerCase()).addClass('active');
        $('#check-month-rad1').addClass('selected');
        $('.rad1_month_inp_dy').val(now_date);
        $('.rad2_month_inp_po').val('1');
        $('.rad2_month_inp_dy').val(now_day_lbl);
        $('#check-year-rad1').addClass('selected');
        $('.rad1_year_inp_mo').val(now_month);
        $('.rad1_year_inp_dy').val(now_date);
        $('.rad2_year_inp_dy').val(now_day_lbl);
        $('.rad2_year_inp_mo').val(now_month);
      } else if (freq == 'weekly') {
        // Set defaults
        $('#check-month-rad1').addClass('selected');
        $('.rad1_month_inp_dy').val(now_date);
        $('.rad2_month_inp_po').val('1');
        $('.rad2_month_inp_dy').val(now_day_lbl);
        $('#check-year-rad1').addClass('selected');
        $('.rad1_year_inp_mo').val(now_month);
        $('.rad1_year_inp_dy').val(now_date);
        $('.rad2_year_inp_dy').val(now_day_lbl);
        $('.rad2_year_inp_mo').val(now_month);
      } else if (freq == 'monthly') {
        // Set defaults
        $('#weekdays .wkdys' + now_day_lbl.toLowerCase()).addClass('active');
        $('#check-year-rad1').addClass('selected');
        $('.rad1_year_inp_mo').val(now_month);
        $('.rad1_year_inp_dy').val(now_date);
        $('.rad2_year_inp_dy').val(now_day_lbl);
        $('.rad2_year_inp_mo').val(now_month);
      } else if (freq == 'yearly') {
        // Set defaults
        $('#weekdays .wkdys' + now_day_lbl.toLowerCase()).addClass('active');
        $('#check-month-rad1').addClass('selected');
        $('.rad1_month_inp_dy').val(now_date);
        $('.rad2_month_inp_po').val('1');
        $('.rad2_month_inp_dy').val(now_day_lbl);
      }
    },
    setup: function () {
      let iso_num = '';
      let iso_day = '';
      // Variables
      let freq = '', interval = '', byday = '', count = '', until = '', bymonthday = '', bysetpos = '', bymonth = '';
      // Get rule (if any)
      let rrl = $('#rrule_fin').val();

      // Hide all options
      $('#weekdays').hide();
      $('#year-inps').hide();
      $('#month-inps').hide();
      $('#end-date').hide();
      $('#end-num').hide();

      // Any rule
      if (rrl != '') {
        // Rule
        let str = $('#rrule_fin').val().toLowerCase();
        // Split
        let strarr = str.split(';');

        // Loop
        for (let i = 0; i < strarr.length; i++) {
          // Split values
          let itmarr = strarr[i].split('=');
          // Get values
          let rnam = itmarr[0];
          let rval = itmarr[1];

          // FREQ
          if (rnam == 'freq') { freq = rval; }

          // Interval
          if (rnam == 'interval') { interval = rval; }

          // Count
          if (rnam == 'count') { count = rval; }

          // Until
          if (rnam == 'until') { until = rval; }

          // Byday
          if (rnam == 'byday') { byday = rval; }

          // Bymonthday
          if (rnam == 'bymonthday') { bymonthday = rval; }

          // Bymonth
          if (rnam == 'bymonth') { bymonth = rval; }

          // Bysetpos
          if (rnam == 'bysetpos') { bysetpos = rval; }
        }

        // Empty values
        if (interval == '' || interval == '0') {
          interval = "1";
        }

        // Set "freq"
        if (freq == 'daily') {
          // Set
          $('#interval').val('day');
          $('#interval-num').val(interval);
        } else if (freq == 'weekly') {
          // Set
          $('#interval').val('week');
          $('#weekdays').show();

          // Add ","
          byday = byday + ',';
          // Split values
          let bydarr = byday.split(',');

          // Loop days
          for (let io = 0; io < bydarr.length; io++) {
            // Contains anything?
            if (bydarr[io] != '') {
              // Add active
              $('#weekdays .wkdys' + bydarr[io]).addClass('active');
            }
          }
        } else if (freq == 'monthly') {
          $('#interval').val('month');
          $('#month-inps').show();

          // Toggle
          if (bymonthday != '') {
            $('#check-month-rad1').addClass('selected');
            $('.rad1_month_inp_dy').val(bymonthday);
          } else {
            // Isolate number
            iso_num = byday;
            iso_num = iso_num.replace('mo', '');
            iso_num = iso_num.replace('tu', '');
            iso_num = iso_num.replace('we', '');
            iso_num = iso_num.replace('th', '');
            iso_num = iso_num.replace('fr', '');
            iso_num = iso_num.replace('sa', '');
            iso_num = iso_num.replace('su', '');

            // Isolate day
            iso_day = byday;
            iso_day = iso_day.replace('1', '');
            iso_day = iso_day.replace('2', '');
            iso_day = iso_day.replace('3', '');
            iso_day = iso_day.replace('4', '');
            iso_day = iso_day.replace('-1', '');
            iso_day = iso_day.replace('-', '');

            $('#check-month-rad2').addClass('selected');
            $('.rad2_month_inp_po').val(iso_num);
            $('.rad2_month_inp_dy').val(iso_day.toUpperCase());

          }

        } else if (freq == 'yearly') {
          $('#interval').val('year');
          $('#year-inps').show();

          if (bymonthday != '') {
            $('#check-year-rad1').addClass('selected');
            $('.rad1_year_inp_mo').val(bymonth);
            $('.rad1_year_inp_dy').val(bymonthday);

          } else {
            // Isolate number
            iso_num = byday;
            iso_num = iso_num.replace('mo', '');
            iso_num = iso_num.replace('tu', '');
            iso_num = iso_num.replace('we', '');
            iso_num = iso_num.replace('th', '');
            iso_num = iso_num.replace('fr', '');
            iso_num = iso_num.replace('sa', '');
            iso_num = iso_num.replace('su', '');
            iso_num = iso_num.replace(/,/gi, '');

            // Isolate day
            iso_day = byday;
            iso_day = iso_day.replace('1', '');
            iso_day = iso_day.replace('2', '');
            iso_day = iso_day.replace('3', '');
            iso_day = iso_day.replace('4', '');
            iso_day = iso_day.replace('-1', '');
            iso_day = iso_day.replace('-', '');

            $('#check-year-rad2').addClass('selected');
            $('.rad2_year_inp_po').val(iso_num);
            $('.rad2_year_inp_dy').val(iso_day.toUpperCase());
            $('.rad2_year_inp_mo').val(bymonth);
          }
        }

        /* END
        -------------------------------------------------- */
        // Set "until"
        if (until != '') {
          // Get date info
          let yr = until.substr(0, 4);
          let mo = until.substr(4, 2);
          let dy = until.substr(6, 2);
          let mo_lbl = '';

          // Toggle month
          if (mo == '01') {
            mo_lbl = "Jan";
          } else if (mo == '02') {
            mo_lbl = "Feb";
          } else if (mo == '03') {
            mo_lbl = "Mar";
          } else if (mo == '04') {
            mo_lbl = "Apr";
          } else if (mo == '05') {
            mo_lbl = "May";
          } else if (mo == '06') {
            mo_lbl = "Jun";
          } else if (mo == '07') {
            mo_lbl = "Jul";
          } else if (mo == '08') {
            mo_lbl = "Aug";
          } else if (mo == '09') {
            mo_lbl = "Sep";
          } else if (mo == '10') {
            mo_lbl = "Oct";
          } else if (mo == '11') {
            mo_lbl = "Nov";
          } else if (mo == '12') {
            mo_lbl = "Dec";
          }

          // Final date
          let da_fin = mo_lbl + ' ' + dy + ', ' + yr;

          // Set
          $('#end').val('ondate');
          $('#end-date-val').val(da_fin);
          $('#end-date').show();

          // Get start date
          let sda = $("#end-date-val").datepicker('getDate');

          // Get dates
          let sdaf = sda.getFullYear() + ('0' + (sda.getMonth() + 1)).slice(-2) + ("0" + sda.getDate()).slice(-2) + 'T235959';

          // Update
          $("#end-date-val").attr('data-date', sdaf);
        } else if (count != '') {
          // Set
          $('#end-num-val').val(count);
          $('#end-num').show();
          $('#end').val('after');
        } else {
          // Set
          $('#end').val('never');
        }
      }

      if (freq == 'yearly') {
        $('#interval-num-rw').hide();
      } else {
        $('#interval-num-rw').show();
      }

      // Window width
      $('#rrule-pop').removeClass('w1 w2');

      if (freq == 'monthly') {
        $('#rrule-pop').addClass('w2');
      } else if (freq == 'yearly') {
        $('#rrule-pop').addClass('w1');
      }
    },
    interval: function (f) {
      // Update RRULE
      rrule.getrule();
      // Get setup
      rrule.setup();
    },
    weekdaysday: function (f) {
      // Active?
      if ($(f).hasClass('active')) {
        // Remove
        $(f).removeClass('active');
      } else {
        // Set
        $(f).addClass('active');

      }

      // Active count
      let count = 0;

      // Loop, count active days
      $('#weekdays .active').each(function () {
        count = count + 1;
      });

      // No days, set monday to active
      if (count == '0') {
        $(f).addClass('active');
      }

      // Update RRULE
      rrule.getrule();
    },
    end: function (f) {
      // Get value
      let val = $('#end').val();

      // Hide all
      $('#end-num').hide();
      $('#end-date').hide();

      // Toggle
      if (val == 'never') {

        // Hide
        $('#end-num').hide();

      } else if (val == 'after') {

        // Show
        $('#end-num').show();

        // Set to one, if nothing
        if ($('#end-num-val').val() == '') {
          $('#end-num-val').val('1');
        }

      } else if (val == 'ondate') {
        // Show
        $('#end-date').show();
      }

      // Update RRULE
      rrule.getrule();
    },
    yearrad: function (f) {
      // Reset
      $('#year-inps .radio-t1').removeClass('selected');
      // Set to active
      $(f).addClass('selected');
      // Update RRULE
      rrule.getrule();
    },
    monthrad: function (f) {
      // Reset
      $('#month-inps .radio-t1').removeClass('selected');
      // Set to active
      $(f).addClass('selected');
      // Update RRULE
      rrule.getrule();
    },
    readmore: function (f) {
      // Get rel
      let rel = $(f).attr('data-rel');
      // Hide
      $(f).hide();
      // Show
      $('#' + rel).show();
    },
    getrule: function () {
      // Final string
      let str = '';
      // Get value
      let val = $('#interval').val();
      let end = $('#end').val();

      //RRULE:FREQ=MONTHLY;INTERVAL=18;COUNT=10;BYMONTHDAY=10,11,12,13,14,15
      // Frequence type
      if (val == 'year') {
        // Collect
        str += 'FREQ=YEARLY;';
      } else if (val == 'month') {
        // Collect
        str += 'FREQ=MONTHLY;';

        if ($('#interval-num').val() != '1') {
          str += 'INTERVAL=' + $('#interval-num').val() + ';';
        }
      } else if (val == 'week') {
        // Collect
        str += 'FREQ=WEEKLY;';

        if ($('#interval-num').val() != '1') {
          str += 'INTERVAL=' + $('#interval-num').val() + ';';
        }

      } else if (val == 'day') {

        // Collect
        str += 'FREQ=DAILY;';

        if ($('#interval-num').val() != '1') {
          str += 'INTERVAL=' + $('#interval-num').val() + ';';
        }
      }

      // INTERVAL

      // End
      if (end == 'never') {

        // Return nothing
        // FREQ=DAILY;INTERVAL=2

      } else if (end == 'after') {

        // Collect
        if ($('#end-num-val').val() != '') {
          str += 'COUNT=' + $('#end-num-val').val() + ';';
        }

        // FREQ=DAILY;INTERVAL=2;COUNT=3

      } else if (end == 'ondate') {
        // Collect
        str += 'UNTIL=' + $('#end-date-val').attr('data-date') + ';';

        // FREQ=DAILY;INTERVAL=2;UNTIL=20191130T080000Z
      }

      // Toggle
      if (val == 'year') {

        // Option 1
        if ($('#check-year-rad1').hasClass('selected')) {

          // Collect
          str += 'BYMONTH=' + $('.rad1_year_inp_mo').val() + ';';
          str += 'BYMONTHDAY=' + $('.rad1_year_inp_dy').val() + ';';

          // FREQ=YEARLY;BYMONTH=3;BYMONTHDAY=12;UNTIL=20191130T080000Z
        }

        // Option 2
        if ($('#check-year-rad2').hasClass('selected')) {
          // Collect
          str += 'BYMONTH=' + $('.rad2_year_inp_mo').val() + ';';
          str += 'BYDAY=' + $('.rad2_year_inp_po').val() + $('.rad2_year_inp_dy').val() + ';';

          // FREQ=YEARLY;BYDAY=TU;BYSETPOS=1;BYMONTH=4;UNTIL=20191130T080000Z
        }

      } else if (val == 'month') {
        // Option 1
        if ($('#check-month-rad1').hasClass('selected')) {
          // Collect
          str += 'BYMONTHDAY=' + $('.rad1_month_inp_dy').val() + ';';

          // FREQ=MONTHLY;BYMONTHDAY=2;INTERVAL=1;UNTIL=20191130T080000Z
        }

        // Option 2
        if ($('#check-month-rad2').hasClass('selected')) {
          // Collect
          str += 'BYDAY=' + $('.rad2_month_inp_po').val() + $('.rad2_month_inp_dy').val() + ';';
        }

      } else if (val == 'week') {
        // Day vals
        let dvls = "";

        // Loop, add day
        $('#weekdays ul .active').each(function () {
          dvls += $(this).attr('data-val') + ',';
        });

        // Remove last comma
        dvls = dvls.replace(/,\s*$/, "");
        // Collect
        str += 'BYDAY=' + dvls + ';';

        // FREQ=WEEKLY;BYDAY=SU,MO,TU,WE;INTERVAL=2;UNTIL=20191130T080000Z
      }

      // Remove last semi colon
      str = str.replace(/;\s*$/, "");

      // Update
      $('#rrule_fin').val(str);

      // Setup
      rrule.setup();

    },
    formsave: function () {
      // Get rule
      let rrl = $('#rrule_fin').val();

      // Get rule explaination
      let exp = rrule.rruleexp(rrl);

      // Any rule?
      if (rrl != "") {

        // Show + update rule
        $('#recurring-form-exp').show();
        $('#recurring-exp-rule').text(exp);

        // Set
        $('#check-recurring').addClass('selected');
        $('#recurring').val('true');
        $('#recurring_rule').val(rrl);
      }

      // Hide
      rrule.hide();
    },
    formcancel: function () {
      // Hide
      rrule.hide();
    },
    show: function (f) {
      // Show
      $('#rrule-pop').show();
      $('#rrule-pop-bg').show();

      // Get dimensions
      let wh = $(window).height();
      let st = $(document).scrollTop();
      let ph = $('#rrule-pop').outerHeight();
      let nt = st + ((wh / 2) - (ph / 2)) - 30;

      // No negative
      if (nt < 50) { nt = 50; }

      // Set popup top
      $('#rrule-pop').css('top', nt + 'px');

      // Timed show
      setTimeout(function () {
        $('#rrule-pop').addClass('show');
        $('#rrule-pop-bg').addClass('show');
      }, 200);

      // Reset
      $('#check-month-rad1, #check-month-rad2').removeClass('selected');
      $('#check-year-rad1, #check-year-rad2').removeClass('selected');

      // Get rule from form
      let rrl = $('#recurring_rule').val();

      // No rule?
      if (rrl == '') {
        // Todays date variables
        let d = new Date();
        let now_day = d.getUTCDay();
        let now_day_lbl = 'MO';

        // Toggle today labels
        if (now_day == '0') {
          now_day_lbl = "SU";
        } else if (now_day == '1') {
          now_day_lbl = "MO";
        } else if (now_day == '2') {
          now_day_lbl = "TU";
        } else if (now_day == '3') {
          now_day_lbl = "WE";
        } else if (now_day == '4') {
          now_day_lbl = "TH";
        } else if (now_day == '5') {
          now_day_lbl = "FR";
        } else if (now_day == '6') {
          now_day_lbl = "SA";
        }

        // Standard rule
        $('#rrule_fin').val('FREQ=WEEKLY;COUNT=1;BYDAY=' + now_day_lbl);
      } else {
        // Update
        $('#rrule_fin').val(rrl);
      }

      // Setup
      rrule.initsetup();
      // Setup
      rrule.setup();
    },
    hide: function (f) {
      // Hide
      $('#rrule-pop').removeClass('show');
      $('#rrule-pop-bg').removeClass('show');

      // Timed hide
      setTimeout(function () {
        // Hide
        $('#rrule-pop').hide();
        $('#rrule-pop-bg').hide();
      }, 200);

      // Get rule
      let rrl = $('#recurring_rule').val();
      // Any rule?
      if (rrl == '') {
        // Remove
        $('#recurring').val('false');
        $('#check-recurring').removeClass('selected');
      }
    },
    generatewindow: function (f) {
      // Does window exists?
      if (!document.getElementById('rrule-pop')) {
        // Post
        $.ajax({
          type: 'GET',
          url: '/c/documentation/rrule-generator',
          success: function (data) {

            // Append
            $('body').append(data);
            // Initialize form fields
            rrule.initialize();
            // Bind
            $('.selectabletext').on('click', function () { codemarkup.selectableinputclick(this); });
            // Show
            rrule.show(f);
          }
        });
      } else {
        // Show
        rrule.show(f);
      }
    },
    initializedocswindow: function () {
      // General window link (used on documenation pages)
      $('.rrulegeneratewindow').on('click', function () { rrule.generatewindow(this); return false; });
    }
  };
}();

// Attach
$(document).ready(function () { rrule.initialize(); rrule.initializedocswindow(); });

/* Guides
---------------------------------------------------------------- */
var openguide = function () {
  return {
    initialize: function (f) {
      // Attach
      $('.openguide').on('click', function () { openguide.show(this); return false; });
    },
    show: function (f) {
      // Get guide
      let gui = $(f).attr('data-guide');

      // Remove container
      $('body').find('.popexm-pop-t1').remove();
      $('body').find('.popexm-pop-t1-bg').remove();

      // Variables
      let html = '', ofw = $(f).width(), ofl = $(f).offset().left, oft = $(f).offset().top, st = $(window).scrollTop();

      // Popup
      html += '<div class="exm-pop-t1-bg" id="open-guide-bg"></div>';
      html += '<div class="exm-pop-t1" id="open-guide"></div>';
      // Add container
      $('body').append(html);
      // Loading
      notificator.show('Loading..');
      // Data
      let dat = 'guide=' + gui;

      // Post
      $.ajax({
        type: 'POST',
        url: '/misc/ajax-popup-guide',
        data: dat,
        success: function (data) {
          // Break
          notificator.break();

          // Append
          $('#open-guide').html(data);
          // Set top
          $('#open-guide').css('top', (st + 30) + 'px');
          // Attach
          $('#open-guide .modal-close').on('click', function () { openguide.hide(this); return false; });
          // Run copy
          $('.copycodex').on('click', function () { copycodex.copy(this); });
          // Selectable text
          $('.selectabletext').on('click', function () { codemarkup.selectableinputclick(this); });
          // Prevent
          $('#open-guide').on('click', function (event) { event.stopPropagation(); });
          // Find textarea
          let are = $('#open-guide textarea').first();

          // Show
          $('#open-guide').show();
          $('#open-guide-bg').show();
          // Set
          $(are).css('height', '10px');

          // Timed adjustment
          setTimeout(function () {
            // Get scroll height
            let sch = document.getElementById("codecopy1").scrollHeight;
            // Reset adjusted height
            $(are).css('height', (sch + 20) + 'px');
            $('#open-guide .tx-t3 .ar').css('height', (sch + 20) + 'px');
          }, 200);

          // Timed show
          setTimeout(function () {
            // Add class
            $('#open-guide').addClass('show');
            $('#open-guide-bg').addClass('show');

          }, 200);
        }
      });

      // Unbind
      $(document).unbind(".popopenguide");
      // Timed
      setTimeout(function () {
        // Bind
        $(document).bind("click.popopenguide", function () { openguide.hide(); });
      }, 200);
    },
    hide: function () {
      // Remove show
      $('#open-guide').removeClass('show');
      $('#open-guide-bg').removeClass('show');

      // Timed show
      setTimeout(function () {
        // Hide
        $('#open-guide').hide();
        $('#open-guide-bg').hide();
      }, 400);
    }
  };
}();

// Attach
$(document).ready(function () { openguide.initialize(); });

/* FAQ help center
---------------------------------------------------------------- */

var faqhc = function () {
  // Set
  let rsload = false, searchdelay = null;

  return {
    initialize: function (f) {
      // Focus
      if ($('#searchform').length) {
        // Return
        $('#searchform').on('submit', function () { return false; });
        // Focus
        $('#searchform input').focus();
        // Bind key press
        $('#searchform input').on('keyup', function (e) {
          // Get input value
          let inp = $('#searchform input').val();
          // Clear
          clearTimeout(searchdelay);
          // Find
          searchdelay = setTimeout(function () {
            faqhc.findix(e, inp, false);
          }, 200);
        });
      }
    },
    findix: function () {
      // Get input value
      let inp = $('#searchform input').val();
      // Set
      let filter = inp;
      // Check if string contains more than two characters
      let match = filter.match(/([A-Za-z])/g);
      if (match && match.length >= 2) {
        // Load
        $('#searchform .loading').css('visibility', 'visible');
        // Data
        let dat = 'search=' + inp;
        // URL encode input
        inp = encodeURIComponent(inp);
        // Ajax
        $.ajax({
          type: 'POST',
          data: dat,
          url: '/c/help/search',
          cache: false,
          success: function (data) {
            // Show / hide
            $('#searchpre').hide();
            $('#searchcoll').show();
            // Append
            $('#searchcoll').html(data);
            // Timed hide
            setTimeout(function () {
              // Load
              $('#searchform .loading').css('visibility', 'hidden');
            }, 300);
          }
        });
      } else {
        // Show / hide
        $('#searchpre').show();
        $('#searchcoll').hide();
      }
    },
    findiload: function (e, val, trigger) {
      // Run ajax if load items hasn't been set
      if (!rsload) {
        // Set
        rsload = true;
        // Load
        $('#searchform .loading').css('visibility', 'visible');

        // Ajax
        $.ajax({
          type: 'POST',
          url: '/c/help/search',
          cache: false,
          success: function (data) {
            // Append
            $('#searchyses ul').html(data);

            // Timed hide
            setTimeout(function () {
              // Load
              $('#searchform .loading').css('visibility', 'hidden');
            }, 700);

            // Trigger?
            if (trigger) {
              faqhc.findi(e, val);
            }
          }
        });
      }
    },
    findi: function (e, val, trigger) {
      // Load items
      if (!rsload) {
        faqhc.findiload(e, val, trigger);
      }

      // Use
      if (!trigger) {
        // Hide results
        $('#searchcoll .itx').hide();
        $('#searchcoll .itx').attr('data-total', '0');

        // Set values
        let filter = val;
        let results = 0;
        let resvalid = false;
        let resultz = [];
        // Check if string contains more than two characters
        let match = filter.match(/([A-Za-z])/g);
        if (match && match.length >= 2) {
          // Actually searching
          resvalid = true;

          // Lowercase
          filter = val.toLowerCase().split(' ');

          // Search through items
          $('#searchcoll .keys').each(function () {
            // Get content
            let text = $(this).text().toLowerCase();

            // Total
            let tot = 0;

            // Loop items in string
            for (let f = 0; f < filter.length; f++) {
              // Count matches
              let cot = (text.match(new RegExp(filter[f], "g")) || []).length;
              // Add
              tot = tot + cot;

              if (text.indexOf(filter[f]) > -1) {
                // Find li
                let bas = $(this).closest('.itx');
                // Update
                $(bas).attr('data-total', tot);

                // Get id
                let fid = $(bas).attr('id');
                // Push
                resultz.push([tot, fid]);
                // Show it
                $(bas).show();

                // Add
                results++;
                // Break loop
                break;
              }
            }
          });

          // Sort
          resultz.sort(function (a, b) {
            return b[0] - a[0]
          });

          // Reset
          $('#searchysesfinul').html('');

          // Loop sorted results
          for (let x = 0; x < resultz.length; x++) {
            let tx = resultz[x].toString().split(',');
            // Get id
            let fix = tx[1];

            if (fix) {
              // Get contents of result
              const con = $('#' + fix).html();

              // Append to final list
              $('#searchysesfinul').append('<li class="itx">' + con + '</li>');
            }
          }
        }

        // Valid search
        if (resvalid) {
          // Update URL
          window.history.pushState('search', 'Title', '/help/?q=' + encodeURIComponent(val));

          // Update search word
          $('#searchnores strong').text(val);

          // Show / hide
          $('#searchpre').hide();
          $('#searchcoll').show();
          $('#rsfnd').show();

          // Results counter
          if (results == '1') {
            $('#rsfnd').text(results + ' match');
          } else {
            $('#rsfnd').text(results + ' matches');
          }

          // Any results?
          if (results > 0) {
            $('#searchnores').hide();
            $('#searchyses').show();
            //$('#rsfnd').show();
          } else {
            $('#searchnores').show();
            $('#searchyses').hide();
            //$('#rsfnd').hide();
          }
        } else {
          // Show / hide
          $('#searchpre').show();
          $('#searchcoll').hide();
          $('#rsfnd').hide();
        }
      }
    }
  };
}();

// Attach
$(document).ready(function () { faqhc.initialize(); });

/* Subscription management
---------------------------------------------------------------- */

var pypobskt = function () {
  // Global variables
  let stripeobj = null, stripeinit = false;
  return {
    initialize: function () {
      // Plans upgrade
      $('.pricing .plnsel a').on('click', function () { pypobskt.pllimngshow(this); return false; });

      // Global card update
      if ($('#cardchangeglobal').length) {
        // Attach
        $('#cardchangeglobal').on('click', function () { pypobskt.cardchangeglobalinit(this); });

        // Initialize Stripe
        pypobskt.stripeinit();
      }
    },
    cardchangeglobalinit: function (f) {
      // Get data
      const acc_id = $(f).attr('data-client-id');
      const stc_id = $(f).attr('data-stripe-customer-id');

      // Notificator
      notificator.show('Redirecting..');

      // Disable
      $('#cardchangeglobal').attr('disabled', true);
      $('#cardchangeglobal').addClass('loading');

      // Get data
      let dat = 'account_clientid=' + acc_id + '&stripe_customer_id=' + stc_id + '&type=global';

      // POST
      $.ajax({
        type: 'POST',
        url: '/change-payment-session',
        data: dat,
        cache: false,
        success: function (data) {

          // Parse
          var obj = jQuery.parseJSON(data);

          // OK
          if (obj.error == 'false' && obj.session_id != '') {

            // Notificator
            setTimeout(function () {
              notificator.break();
            }, 800);

            // Redirect to checkout
            stripeobj.redirectToCheckout({ sessionId: obj.session_id });

          } else if (obj.error == 'true' && obj.error_desc != '') {

            // Error
            alert(obj.error_desc);

          } else {

            // Error
            alert('Something went wrong. Please try again. ');
          }
        }
      });
    },
    stripeinit: function () {
      // Initialized?
      if (!stripeinit) {
        // Stripe script
        let ss = document.createElement('script');

        // Set
        ss.type = 'text/javascript';
        ss.src = 'https://js.stripe.com/v3/';
        ss.async = true;

        // Apply
        document.body.appendChild(ss);

        // Observe
        ss.onload = function () {
          // Create a Stripe client.
          stripeobj = Stripe(stripeApiKey);
        };

        // Set
        stripeinit = true;
      }
    },
    pllimngshow: function (f) {
      // Get action
      let act = $(f).attr('data-plan');
      // Unbind
      $(document).unbind(".pllimngpop");
      // Timed
      setTimeout(function () {
        // Bind
        $(document).bind("click.pllimngpop", function (event) {
          // Hide
          pypobskt.plliplshide();
        });
      }, 200);

      // Data
      let dat = 'plan=' + act;
      // Notificator
      notificator.show('Loading..');

      // POST
      $.ajax({
        type: 'POST',
        url: '/plans-and-pricing/select-plan-popup',
        data: dat,
        cache: false,
        success: function (data) {
          // Append
          $('#pypo-plans').html(data);
          // Notificator
          notificator.break();
          // Attach
          $('#pypo-form').on('submit', function () { return pypobskt.pypobsktvalidate(this); });
          $('#pypo-plans .close-t1').on('click', function () { pypobskt.plliplshide(this); return false; });
          $('#pypo-plans .op-t2 .rw').on('click', function () { pypobskt.oprwsel(this); return false; });
          $('#pypo-plans .moropts a').on('click', function () { pypobskt.pllimngexpopts(this); return false; });
          $('#pypo-plans').on('click', function (event) { event.stopPropagation(); });

          // Get dimensions
          let st = $(window).scrollTop();
          // Adjust
          $('#pypo-plans').css('top', (st + 40) + 'px');

          // Remove hide class
          $('#pypo-plans').removeClass('hide');
          $('#pypo-plans-bg').removeClass('hide');

          // Show
          $('#pypo-plans').show();
          $('#pypo-plans-bg').show();

          // Timed show
          setTimeout(function () {

            // Show
            $('#pypo-plans').addClass('show');
            $('#pypo-plans-bg').addClass('show');

          }, 200);

          // Stripe init
          pypobskt.stripeinit();
          // Tooltip
          tooltip.initialize();
        }
      });
    },
    plliplshide: function (f) {
      // Unbind
      $(document).unbind(".plliplspop");

      // Hide
      $('#pypo-plans').removeClass('show');
      $('#pypo-plans-bg').removeClass('show');

      // Timed show
      setTimeout(function () {
        // Hide
        $('#pypo-plans').hide();
        $('#pypo-plans-bg').hide();
      }, 200);
    },
    pypobsktvalidate: function (f) {
      // Remove error classes
      $('.inperr').removeClass('inperr');
      $('.warning').hide();

      // Disable
      $('#pypo-form .submit').attr('disabled', true);
      $('#pypo-form .submit').addClass('loading');

      // Signup or change of plans?
      let typ = $('#pypo-form').attr('data-plan-change');

      // Toggle
      if (typ == 'true') {
        // Notificator
        notificator.show('Processing');
        // Get data
        let dat = $("#pypo-form").serialize();

        // POST
        $.ajax({
          type: 'POST',
          url: '/plans-and-pricing/subscription-change',
          data: dat,
          cache: false,
          dataType: 'json',
          success: function (data) {
            // Get obj
            let obj = data;

            // OK?
            if (obj.meta.code == '400') {
              // Show
              $('#err-card').show();
              $('#err-card p').text(obj.error.description);

              // Enable
              $('#pypo-form .submit').attr('disabled', false);
              $('#pypo-form .submit').removeClass('loading');
            } else {
              // Change type
              if (obj.meta.type == 'subscription_change') {
                if (obj.subscription.latest_invoice.payment_intent !== null && obj.subscription.latest_invoice.payment_intent !== '') {
                  // OK or "requires action"?
                  if (obj.subscription.latest_invoice.payment_intent.status == 'requires_action' || obj.subscription.latest_invoice.payment_intent.status == 'requires_source_action') {

                    // Show
                    $('#err-card').show();
                    $('#err-card p').text('Payment method awaits authentication');

                    stripeobj
                      .confirmCardPayment(obj.subscription.latest_invoice.payment_intent.client_secret)
                      .then(function (result) {
                        // Authentication status
                        if (result.paymentIntent) {
                          // Success

                          // Adjust plan
                          pypobskt.pllimngadjustplan(result.paymentIntent.id);
                        } else {
                          // Enable
                          $('#pypo-form .submit').attr('disabled', false);
                          $('#pypo-form .submit').removeClass('loading');

                          // Show
                          $('#err-card').show();
                          $('#err-card p').text('Payment method authentication was canceled or failed.');
                        }
                      });
                  } else if (obj.subscription.latest_invoice.payment_intent.status == 'succeeded') {
                    // Success
                    // Adjust plan
                    pypobskt.pllimngadjustplan(obj.subscription.latest_invoice.payment_intent.id);
                  } else {
                    // Something went wrong
                    alert('Sorry, something went wrong.. Please try again or contact support. ');
                  }
                } else if (obj.subscription.latest_invoice.paid == 'true') {
                  // User e.g. downgraded and we did not get a payment intent
                  pypobskt.pllimngadjustplan(obj.subscription.customer);
                } else {
                  // User e.g. downgraded and we did not get a payment intent
                  pypobskt.pllimngadjustplan(obj.subscription.customer);
                }
              } else if (obj.meta.type == 'subscription_reactivate') {
                // Redirect to confirm
                console.log('reactivate');
              } else if (obj.meta.type == 'subscription_cancel') {
                // Redirect to confirm
                console.log('cancel');
              }
            }
          }
        });
      } else {
        // Notificator
        notificator.show('Proceeding to checkout..');
        // Get data
        let dat = $("#pypo-form").serialize();

        // POST
        $.ajax({
          type: 'POST',
          url: '/plans-and-pricing/signup-plan-session',
          data: dat,
          cache: false,
          dataType: 'json',
          success: function (data) {
            // Parse
            const obj = data;

            // OK
            if (obj.error == 'false' && obj.session_id != '') {
              // Notificator
              setTimeout(function () {
                notificator.break();
              }, 800);

              // Redirect to checkout
              stripeobj.redirectToCheckout({ sessionId: obj.session_id });
            } else if (obj.error == 'true' && obj.error_desc != '') {
              // Error
              alert(obj.error_desc);
            } else {
              // Error
              alert('Something went wrong. Please try again. ');
            }
          }
        });
      }

      // Return
      return false;
    },
    oprwsel: function (f) {
      // Get current plan (if any)
      let cpl = $('#pypo-form .current_plan').val();
      // Get plan and pricing
      let pln = $(f).attr('data-cycle');
      let pnu = $(f).attr('data-plan-num');
      let cou = $(f).attr('data-coupon');

      // Allowed?
      if (cpl != pnu) {
        // Reset
        $('#pypo-plans .op-t2 .rw').removeClass('active');
        // Set selected
        $(f).addClass('active');
        // Remove plan class
        $('#pypo-plans .rel').removeClass('annual monthly');
        // Monthly vs annual
        if (pln == 'month') {
          $('#pypo-plans .rel').addClass('monthly');
        } else {
          $('#pypo-plans .rel').addClass('annual');
        }

        // Update form values
        $('#pypo-form .inpplan').val(pnu);
        $('#pypo-form .inpplan_cycle').val(pln);
        $('#pypo-form .coupon').val(cou);

        // Enable save
        $('#pypo-form .submit').attr('disabled', false);
        $('#pypo-form .submit').removeClass('disabled');
      }
    },
    pllimngexpopts: function (f) {
      // Remove to show
      $('#pypo-plans .cycleopt').removeClass('hidets');
      // Hide
      $('#pypo-plans #moreopts').hide();
    },
    pllimngadjustplan: function (pii) {
      // Data
      let dat = 'payment_intent=' + pii;

      // POST
      $.ajax({
        type: 'POST',
        url: '/plans-and-pricing/subscription-adjustplan',
        data: dat,
        cache: false,
        dataType: 'json',
        success: function (data) {
          // Get obj
          let obj = data;
          // OK
          if (obj.meta.code == '200') {
            // Redirect to confirm
            location.href = '/account/?action=plan_change_success';
          } else {
            // Something went wrong
            alert('Sorry, something went wrong.. Please try again or contact support. ');
          }
        }
      });
    }
  };
}();

// Attach
$(document).ready(function () { pypobskt.initialize(); });

/* Blog
---------------------------------------------------------------- */

var blogjs = function () {
  return {
    initialize: function (f) {
      // Get images
      $(".inimgx").each(function () {
        let src = $(this).attr('data-src');
        // Update parent div
        $(this).attr('style', 'background-image:url(' + src + ');');

        // Change class of object
        $(this).removeClass('inimgx');
        $(this).addClass('inimg');
      });

      // Get images
      $(".inilzy").each(function () {
        // Object
        let src = $(this).attr('data-src');

        // Update parent div
        $(this).attr('src', src);

        // Change class of object
        $(this).removeClass('inilzy');
      });
    }
  };
}();

// Attach
$(document).ready(function (e) {
  // Attach
  setTimeout(function () { blogjs.initialize(); }, 2000);
});

/* Validation
---------------------------------------------------------------- */

var validate = function () {
  return {
    email: function (str) {
      let filter = /^[^\s@]+@[^\s@]+\.[a-z]{2,20}$/i;
      if (filter.test(str)) { return true; } else { return false; }
    },
    empty: function (str) {
      let filter = /^\s+$/;
      let expression;
      if (filter.test(str) || str == '') { expression = false; } else { expression = true; }

      return expression;
    },
    onlynumbers: function (evt) {
      let charCode = (evt.which) ? evt.which : event.keyCode;
      if (charCode > 31 && (charCode < 48 || charCode > 57)) { return false; } else { return true; }
    }
  };
}();

/* CSRF popup
---------------------------------------------------------------- */

var csrfpop = function () {
  return {
    show: function (f, data) {
      // Build menu if it doesn't exists
      csrfpop.typehtml(f, data);
      // Show
      setTimeout(function () { $('#pop-csrf').addClass('show') }, 300);
    },
    refresh: function () {
      // Refresh
      location.reload();
    },
    typehtml: function () {
      // Get object
      let obj = document.getElementById('pop-csrf');
      // Set variable
      let html = '';
      // Add HTML
      if (!obj) {
        // Collect
        html += '<div class="pop-csrf" id="pop-csrf">';
        html += '	<div class="rle">';
        html += '		<div class="lf">';
        html += '			<p>';
        html += '				Looks like you’re a robot. <br />';
        html += '				<span>It’s not you, it’s our system.</span>';
        html += '			</p>';
        html += '		</div>';
        html += '		<div class="rg">';
        html += '			<input type="button" value="Refresh" class="leave" />';
        html += '		</div>';
        html += '		<div class="cl"></div>';
        html += '	</div>';
        html += '</div>';

        // Append
        $("body").append(html);
        // Append
        $('#pop-csrf .refresh').on('click', function () { csrfpop.refresh(this); });
        $('#pop-csrf .leave').on('click', function () { location.href = 'https://www.addevent.com'; });
      }
    }
  };
}();

/* Google tag manager
---------------------------------------------------------------- */

// Load script
(function(w,d,s,l,i){
  w[l]=w[l] || [];
  w[l].push(
    {'gtm.start': new Date().getTime(), event:'gtm.js'}
  );
  let f = d.getElementsByTagName(s)[0],
  j = d.createElement(s), dl = l!='dataLayer' ? '&l='+l:'';
  j.async = true;
  j.src = 'https://www.googletagmanager.com/gtm.js?id='+i+dl;
  f.parentNode.insertBefore(j,f);
})(window,document,'script','dataLayer','GTM-MD4C6KL3');

const hubspotContactSetup = function () {
  if (typeof hbspt === 'undefined' || hbspt === null || !window.location.href.includes("/contact/support")) {
    return;
  }

  // Support form
  if($('#hbssupportform').length){

    hbspt.forms.create({
      region: "eu1",
      portalId: "25141523",
      target: "#hbssupportform",
      formId: hubspotContactFormId,
      onFormReady: function () {
        // Form ready
        contactsupportform.populate();
      },
      onFormSubmit: function () {
        // Submit
        contactsupportform.formsubmit();
      },
      onFormSubmitted: function () {
        // Submitted
        contactsupportform.formsubmitted();
      }
    });

  }

};

const hubspotSalesSetup = function () {
  if (typeof hbspt === 'undefined' || hbspt === null || !window.location.href.includes("/contact/sales")) {
    return;
  }

  // Support form
  if($('#hbssalesform').length) {

    hbspt.forms.create({
      region: "eu1",
      portalId: "25141523",
      target: "#hbssalesform",
      formId: hubspotSalesFormId,
      onFormReady: function () {
        // Form ready
        contactsalesform.populate();
      },
      onFormSubmit: function () {
        // Submit
        contactsalesform.formsubmit();
      },
      onFormSubmitted: function () {
        // Submitted
        contactsalesform.formsubmitted();
      }
    });

  }

};

initializeTrackerEvents(aeTracker);

$(document).ready(function () {
  hubspotSalesSetup();
  hubspotContactSetup();
});

// Check for IntersectionObserver support
if('IntersectionObserver' in window){
  // Ready
  $(document).ready(function(){
    function handleIntersection(entries) {
      entries.map((entry) => {
        if (entry.isIntersecting) {
          if ($(entry.target).hasClass('lazyelm')) {

            // Remove hides
            $(entry.target).removeClass('lazyelm');
            $(entry.target).find('.lazyitm').removeClass('lazyitm');

          }

          // Job done for this item - no need to watch it!
          observer.unobserve(entry.target);
        }
      });
    }

    const headers = document.querySelectorAll('.lazyelm');
    const observer = new IntersectionObserver(
      handleIntersection, {
        rootMargin: "100px"
      }
    );

    headers.forEach(header => observer.observe(header));
  });

} else {
  // Remove hides
  $('.lazyelm, .lazyitm').removeClass('lazyelm lazyitm');
}

// Google Lighthouse - to prevent : Does not use passive listeners to improve scrolling performance
jQuery.event.special.touchstart = {
  setup: function( _, ns, handle ) {
    this.addEventListener("touchstart", handle, { passive: !ns.includes("noPreventDefault") });
  }
};
jQuery.event.special.touchmove = {
  setup: function( _, ns, handle ) {
    this.addEventListener("touchmove", handle, { passive: !ns.includes("noPreventDefault") });
  }
};
jQuery.event.special.wheel = {
  setup: function( _, ns, handle ){
    this.addEventListener("wheel", handle, { passive: true });
  }
};
jQuery.event.special.mousewheel = {
  setup: function( _, ns, handle ){
    this.addEventListener("mousewheel", handle, { passive: true });
  }
};
